/* eslint-disable */
<template>
  <loading
    v-model:active="isLoading"
    :can-cancel="false"
    loader="dots"
    color="#007bff"
    :height="45"
    :width="75"
    :is-full-page="true"
  ></loading>
  <div class="d-flex w-100 flex-row-reverse">
    <!-- <v-btn color="primary" class="top-btns ma-5">Email Alerts</v-btn> -->
    <!-- <v-btn color="primary" class="top-btns ma-5">Saved Searches</v-btn> -->
    <!-- <v-btn color="primary" class="top-btns ma-5">Power Search</v-btn> -->
    <v-btn color="primary" class="top-btns ma-5">Export Baskets</v-btn>
    <v-btn color="primary" class="top-btns ma-5" @click="lastSearch"
      >Last Search</v-btn
    >
    <v-btn color="primary" class="top-btns ma-5" @click="lastResult"
      >Last Result</v-btn
    >
  </div>
  <span v-show="Object.keys(actioPayload).length > 0">
    {{ JSON.stringify(actioPayload) }}
    <br />
    <b>Your Search Criteria:</b><br />
    <span v-for="(value, name, index) in searchCriteria[0]" :key="index">
      <span v-if="value !== 0">
        &nbsp;<b>{{ name !== "ocr" && name !== "full" ? name : "" }}</b
        >{{ name !== "ocr" && name !== "full" ? ":" : "" }}
        {{ value.toString() }}
      </span>
    </span>
  </span>
  <div v-if="newdata.length > 0" class="font-weight-bold">
    {{ totalRecords }} Results Found in ( {{ timeTaken }} Seconds)
  </div>

  <!-- my excel -->
  <div v-if="newdata.length > 0" class="font-weight-bold">
    <v-btn color="primary" class="top-btns ma-2" @click="myExcelActivation"
      >My Excel</v-btn
    >
  </div>
  <!-- <div>{{ JSON.stringify(db) }}</div> -->
  <div id="table-container" style="min-height: 100vh; margin: 0">
    <v-table ref="tableRef" id="myTable" height="auto">
      <thead>
        <tr class="result-row custom-table">
          <v-row no-gutters style="min-width: 100%">
            <v-col cols="2" lg="2" xl="2">
              <v-col cols="12">
                <th class="heading-css">Sort By</th>
              </v-col>
            </v-col>
            <v-col cols="5" lg="5" xl="5">
              <v-col cols="12" lg="12" xl="12" class="heading-text">
                <th class="cursor pl-6 heading-css" @click="headlineFnHandler">
                  Headline
                  <v-icon :icon="sortingIcon.headline" />
                </th>
              </v-col>
            </v-col>
            <v-col cols="2" lg="2" xl="2">
              <v-col cols="12" lg="12" xl="12" class="heading-text heading-css">
                <th class="cursor pl-6" @click="headlineFnHandler">
                  Company
                  <v-icon :icon="sortingIcon.company" />
                </th>
              </v-col>
            </v-col>
            <v-col cols="3" lg="3" xl="3">
              <v-col cols="12" lg="12" xl="12">
                <th>
                  <span
                    class="entry-id cursor heading-css"
                    @click="headlineFnHandler"
                    >Entry ID</span
                  ><v-icon :icon="sortingIcon.entry" />
                  <span class="cursor" @click="headlineFnHandler">A</span
                  ><v-icon :icon="sortingIcon.a" />
                  <span class="cursor" @click="headlineFnHandler">S</span
                  ><v-icon :icon="sortingIcon.s" />
                  <span class="cursor" @click="headlineFnHandler">G</span
                  ><v-icon :icon="sortingIcon.g" />
                </th>
              </v-col>
            </v-col>
          </v-row>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="item in newdata"
          :key="item.ProductId"
          ref="eachRow"
          :id="item.ProductId"
        >
          <v-row no-gutters class="table-row">
            <v-row style="min-width: 100%">
              <v-col cols="2" lg="2" xl="2">
                <v-col cols="12" lg="12" xl="12">
                  <td style="cursor: pointer">
                    <v-img
                      ref="img"
                      width="150"
                      height="100"
                      :lazy-src="item.url"
                      :id="item.ProductId"
                      v-bind="props"
                      open-on-hover
                      @mouseover="delayFn(item.ProductId)"
                      class="product-image"
                      :src="
                        !item.url
                          ? img.src
                          : item.url === 'No URL'
                          ? img.src
                          : item.url
                      "
                      alt="logo"
                    >
                    </v-img>
                  </td>
                </v-col>
                <!-- PDF PREVIEW MODAL -->
                <div
                  v-show="dynamicPDFPreview && item.ProductId == currentPID"
                  class="popup-pdf"
                  ref="previewIMG"
                  :id="item.ProductId"
                  transition="fade-transition"
                >
                  <div>
                    <div id="prev">
                      <span style="padding-right: 149px">
                        <v-img
                          width="20"
                          height="20"
                          @click="closePreviewBoxFn(item.ProductId)"
                          src="../assets/close.png"
                          style="border: none; cursor: pointer"
                        />
                      </span>
                      <a
                        @click="openPDF(item.ProductId)"
                        style="cursor: pointer"
                        >View PDF Content
                        <span>
                          <v-img
                            width="20"
                            height="20"
                            src="../assets/pdf.jpg"
                            style="border: none; max-width: 100%"
                          />
                        </span>
                      </a>
                    </div>
                    <div style="width: 100%; text-align: center">
                      <v-img
                        @click="openAdminPDFURL(item.ProductId)"
                        style="
                          cursor: pointer;
                          border: none;
                          vertical-align: middle;
                        "
                        :width="200"
                        :height="336"
                        :lazy-src="dynamicPDFPreview"
                        :src="dynamicPDFPreview"
                      />
                    </div>
                  </div>
                </div>
                <!-- <v-img
                  v-if="!pdfHoverPop && item.ProductId == currentPID"
                  src="../assets/searching.gif"
                  width="30"
                  height="30"
                ></v-img> -->
              </v-col>
              <v-col>
                <div
                  style="display: block; padding-left: 20px; padding-top: 10px"
                >
                  <span class="font-weight-bold fixed-header heading-css"
                    >Headline:</span
                  >
                  <div
                    @mouseover="headlineHover(item.ProductId)"
                    @mouseleave="headlineHover(item.ProductId)"
                    class="heading-css"
                    :class="
                      isHovering && highlightedIndex === item.ProductId
                        ? 'hovering'
                        : 'underline'
                    "
                    @click="openHeadlineFnHandler1(item)"
                    v-if="item.headline?.length > 0"
                  >
                    {{ item.headline }}
                  </div>
                  <span v-else> Not mentioned </span>
                </div>
              </v-col>
              <v-col cols="2" lg="2" xl="2">
                <v-col cols="12" lg="12" xl="12">
                  <td>
                    <div class="fixed-header">
                      <span class="font-weight-bold heading-css"
                        >Primary Company:</span
                      >
                    </div>
                    <div class="heading-css">
                      <span v-if="item.companyName.length > 0">{{
                        item.companyName
                      }}</span>
                      <span v-else>Not mentioned</span>
                    </div>
                  </td>
                </v-col>
              </v-col>
              <v-col cols="3" lg="3" xl="3">
                <v-col cols="12" lg="12" xl="12">
                  <td>
                    <div>
                      <span class="font-weight-bold heading-css pl-1"
                        >EntryID:</span
                      >
                    </div>
                    <div class="heading-css pl-1">
                      <a :href="item.hrefVal" target="_blank">{{
                        item.EntryID
                      }}</a>
                    </div>
                  </td>
                </v-col>
              </v-col>
            </v-row>
            <!-- ---- -->
            <v-row style="min-width: 100%">
              <v-col cols="2" lg="2" xl="2" class="img-box">
                <div class="container">
                  <div class="row">
                    <div class="column">
                      <input
                        class="cartCheckBox"
                        type="checkbox"
                        :id="item.ProductId"
                      />
                      <label :for="item.ProductId">
                        <v-img
                          style="cursor: pointer"
                          :width="30"
                          :height="50"
                          src="./../assets/cart_blue.png"
                        />
                      </label>
                    </div>
                  </div>

                  <div class="row">
                    <div class="column">
                      <a :href="`${pdfPath} ${item.ProductId}`" target="_blank">
                        <v-img
                          :width="20"
                          :height="17"
                          src="./../assets/pdf.jpg"
                        >
                        </v-img>
                      </a>
                      <a
                        class="pdf-link"
                        :href="`${pdfPath} ${item.ProductId}`"
                        target="_blank"
                      >
                        {{ item?.size }}
                      </a>
                    </div>
                    <div class="column">
                      <a :href="`${pptPath} ${item.image}`" target="_blank">
                        <v-img
                          :width="20"
                          :height="17"
                          src="./../assets/ppt.jpg"
                        />
                      </a>
                      <a :href="`${excelPath} ${item.image}`" target="_blank">
                        <v-img
                          :width="20"
                          :height="17"
                          src="./../assets/excel.jpg"
                        />
                      </a>
                      <span v-if="item.isAnimation === true">
                        <a @click="openHtmlTag(htmlPath, item.ProductId)">
                          <v-img
                            :width="20"
                            :height="17"
                            style="margin-right: 3px"
                            src="./../assets/animation_condition.png"
                          />
                        </a>
                      </span>
                      <span
                        v-if="
                          item.isWrench === 0 ||
                          item.isWrench === null ||
                          item.isWrench === undefined
                        "
                      >
                        <span @click="getWrenchHandler(item.muid)">
                          <v-img
                            :width="20"
                            :height="17"
                            src="./../assets/settings-anotation.png"
                          />
                        </span>
                      </span>
                      <span v-if="item.isWrench === 1">
                        <span @click="getWrenchHandler(item.muid)">
                          <v-img
                            :width="20"
                            :height="17"
                            src="./../assets/annotaion-img-Blue.png"
                          />
                        </span>
                      </span>
                      <span v-if="item.isWrench === 2">
                        <span @click="getWrenchHandler(item.muid)">
                          <v-img
                            :width="20"
                            :height="17"
                            src="./../assets/red_annotation.png"
                          />
                        </span>
                      </span>
                    </div>
                  </div>
                </div>
              </v-col>
              <v-col>
                <td>
                  <span class="font-weight-bold heading-css pl-5"
                    >MediaChannel:</span
                  >
                  <div class="heading-css pl-5">
                    <span v-if="item.MediaChannel.length > 0">
                      {{ item.MediaChannel }}
                    </span>
                    <span v-else> Not mentioned </span>
                  </div>
                </td>
              </v-col>
              <v-col cols="2" lg="2" xl="2">
                <td v-if="item.hideAdditionalCompanies">
                  <span class="font-weight-bold heading-css pl-3"
                    >Additional Companies:</span
                  >
                  <div class="heading-css pl-3">
                    {{ item.additionalCompanies }}
                  </div>
                </td>
                <td v-if="!item.hideAdditionalCompanies">
                  <span class="font-weight-bold heading-css pl-3">Sector:</span>
                  <div class="heading-css pl-3">
                    <span v-if="item.sectorName.length > 0">{{
                      item.sectorName
                    }}</span>
                    <span v-else>Not mentioned</span>
                  </div>
                </td>
              </v-col>
              <v-col cols="3" lg="3" xl="3">
                <td>
                  <div>
                    <span class="font-weight-bold heading-css pl-4"
                      >Category:</span
                    >
                  </div>
                  <div class="heading-css pl-4">
                    <span v-if="item.SubCategory.length > 0">{{
                      item.SubCategory
                    }}</span
                    ><span v-else>Not mentioned</span>
                  </div>
                </td>
              </v-col>
            </v-row>
            <!-- new row -->
            <!-- ---third -->
            <v-row style="min-width: 100%">
              <v-col cols="2" lg="2" xl="2">
                <v-col cols="12" lg="12" xl="12">
                  <td></td>
                </v-col>
              </v-col>
              <v-col>
                <td>
                  <div>
                    <span class="font-weight-bold fixed-header heading-css pl-5"
                      >Audience:</span
                    >
                  </div>
                  <div class="heading-css pl-5">
                    <span v-if="item.Audience.length > 0">
                      {{ item.Audience }}
                    </span>
                    <span v-else> Not mentioned </span>
                  </div>
                </td>
              </v-col>
              <v-col cols="2" lg="2" xl="2">
                <td v-if="item.hideAdditionalCompanies">
                  <div>
                    <span class="font-weight-bold heading-css pl-3"
                      >Sector:</span
                    >
                  </div>
                  <div class="heading-css pl-3">
                    <span v-if="item.sectorName.length > 0">{{
                      item.sectorName
                    }}</span
                    ><span v-else>Not mentioned</span>
                  </div>
                </td>
              </v-col>
              <v-col cols="3" lg="3" xl="3">
                <td>
                  <div class="heading-css">
                    <span class="font-weight-bold heading-css pl-4"
                      >Sub Category:</span
                    >
                  </div>
                  <div class="heading-css pl-4">
                    <span v-if="item.SubSubCategory.length > 0">
                      {{ item.SubSubCategory }}
                    </span>
                    <span v-else> Not mentioned </span>
                  </div>
                </td>
              </v-col>
            </v-row>
            <!-- third ended -->
          </v-row>
        </tr>
      </tbody>
    </v-table>
  </div>
  <v-container class="pa-10" fill-height fluid v-if="dataStatus">
    <!-- <div>
            <ul class="pagination">
              <li
                v-for="pageNumber in displayedPages"
                :key="pageNumber"
                :class="{ active: pageNumber === page.value }"
                @click="pageEventHandler(pageNumber)"
              >
                {{ pageNumber }}
              </li>
            </ul>
          </div>  -->
    <v-row align="center" justify="center">
      <v-btn
        size="small"
        @click="pageEventHandler(1, 'f')"
        :disabled="page === 1"
        >First</v-btn
      >
      <v-btn
        size="small"
        class="grey lighten-4 mr-2"
        @click="pageEventHandler(page - 1, 'p')"
        :disabled="page === 1"
        >Previous</v-btn
      >
      <v-btn
        v-for="pageNumber in displayedPages"
        :key="pageNumber"
        size="small"
        :class="[pageNumber === page ? 'text-danger' : hasError]"
        @click="pageEventHandler(pageNumber, 'n')"
        :disabled="pageNumber === page"
        >{{ pageNumber }}</v-btn
      >
      <v-btn
        @click="pageEventHandler(page + 1, 'next')"
        class="grey lighten-4 ml-2"
        size="small"
        :disabled="page === pageCount"
        >Next</v-btn
      >
      <v-btn
        @click="pageEventHandler(pageCount, 'last')"
        size="small"
        :disabled="page === pageCount"
        >Last</v-btn
      >
    </v-row>
  </v-container>

  <!-- My Excel -->
  <!-- </v-container>
              </v-col>
            </v-row>
          </v-container>
        </div> -->
  <!-- <v-container
    v-if="newdata.length > 0"
    style="position: relative; display: block; left: 602px"
  >
    <div>
      <v-btn color="primary" class="ma-5">My Excel</v-btn>
      <v-btn color="primary" class="ma-5">Express Download</v-btn>
      <v-btn color="primary" class="ma-5">Go To Search</v-btn>
    </div>
    <div class="pb-5">
      <p>
        Competiscan logos are a trademark of Competiscan, LLC that may be
        registered in US and/or other countries.
      </p>
      <p>All other trademarks are the property of their respective owner</p>
    </div>
    <v-footer class="d-flex flex-column">
      <v-row class="d-flex w-100 justify-center">
        <v-col>
          <a class="pa-5 footer-txtcolor link-clr" color="primary"
            >Contact Us</a
          >
          <a class="pa-5 footer-txtcolor link-clr" color="primary"
            >Quick Help</a
          >
          <a class="pa-5 footer-txtcolor link-clr" color="primary"
            >Suggestions</a
          >
          <a class="pa-5 footer-txtcolor link-clr" color="primary"
            >Terms & Conditions</a
          >
        </v-col>
      </v-row>
    </v-footer>
  </v-container> -->
  <!-- </template> -->
  <!-- </v-data-table> -->
  <!-- </v-container> -->
</template>

<script>
/*eslint-disable*/
import {
  ref,
  watchEffect,
  watch,
  watchPostEffect,
  computed,
  inject,
  onMounted,
} from "vue";
// import { VDataTable } from "vuetify/lib/labs/components.mjs";
import { useStore } from "vuex";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/css/index.css";
// import CustomModal from "./reusable/CustomModal.vue";
import VueCookies from "vue-cookies";
import dropdownapis from "../apis/dropdownapi.js";
import notfoundImage from "../assets/imageNotFound.gif";
import { onUpdated } from "vue";
import { useRouter } from "vue-router";

export default {
  components: { Loading },
  props: {
    sendingWidth: String,
  },
  setup(props) {
    const isLoading = ref(false);
    const dataStatus = ref(false);
    const allMuids = ref();
    const router = useRouter();
    const responseMFlagInsurance = ref(false);
    const media = ref("");
    const http = ref(inject("http"));
    const islastResultActive = ref(false);
    const iconShow = ref();
    const productName = ref(false);
    const { dropApiCall } = dropdownapis();
    const IntroductoryPricing = ref([
      { id: 1, value: "Purch Intro" },
      { id: 2, value: "BT Intro" },
      { id: 3, value: "No Purch Intro" },
      { id: 4, value: "No BT Intro" },
    ]);
    const myParagraph = ref(null);
    const sector = ref("");
    const sectorIdsSelected = ref([]);
    const channelMap = ref({
      "Direct Mail": "direct",
      Print: "print_media",
      Email: "email",
      "Online Display": "mobiledigital&product_status=1",
      "Social Media": "social_media",
      "Search Engine Marketing": "mobiledigital&product_status=1",
      "Online Video": "mobiledigital&product_status=1",
      "Dashboard Only": "email",
      "Website/URL": "website_url",
      Email2: "manual_product",
    });
    const persons = [
      { firstName: "John", lastName: "Doe", email: "john@example.com" },
      { firstName: "Jane", lastName: "Doe", email: "jane@example.com" },
      { firstName: "Mike", lastName: "Smith", email: "mike@example.com" },
      // Add more data as needed
    ];
    const dynamicPDFPreview = ref("");
    const sortingIcon = ref({
      headline: "",
      company: "",
      entry: "mdi-menu-down",
      a: "",
      s: "",
      g: "",
    });
    const isSearchAgainFlag = ref(false);
    const audience = ref("");
    const sid = ref([]);
    const lastPageStatus = ref(false);
    const pdfPath = ref("https://www.competiscan.com/productDocuments.php?id=");
    const pptPath = ref(
      "https://www.competiscan.com/productImages.php?pp=1&id="
    );
    const htmlPath = ref("https://www.competiscan.com/processed-html.php?id=");
    const excelPath = ref("https://www.competiscan.com/productImages.php?id=");
    const store = useStore();
    const dataExist = ref(true);
    const paginationColor = ref("primary");
    const dummypids = ref([
      11055139, 11044657, 11024834, 10992153, 10934584, 10980919, 10980886,
      10979507, 10965810, 10966070, 10965870, 10960757, 10918878, 10934617,
      10933402, 10932305, 10914382, 10914383, 9690675, 9680760, 9680965,
      10895713, 10889800, 9700470, 9759024, 9765545, 9754315, 10873476,
      10873463, 9710806, 9724735, 9730851, 10847852, 10847758, 10846117,
      10632065, 10823732, 10753714, 10810076, 10809764, 10802726, 10802651,
      9740059, 10791345, 10792670, 10772801, 10770627, 10243522, 10766097,
      10766339,
    ]);
    const loading = ref(false);
    const page = ref(1);
    const maxPgNum = ref(0);
    const sectorNames = ref([]);
    const myexcelActivateStatusLocal = ref(false);
    const previewCloseFlag = ref(false);
    const DataTableWidth = ref("100%");
    const modalVisible = ref(false);
    const pdfHoverData = ref();
    // const headlineHover = ref(false);
    let actioPayload = ref();
    let searchCriteria = ref([]);
    const highlightedIndex = ref(null);
    const loader = ref(false);
    const lengthRecords = ref();
    const bodyData = ref({
      sortby: "entry_id_sort, desc",
      tiebreaker: "product_id, desc",
    });
    const networkName = ref([
      { id: 0, value: "Any" },
      { id: "facebook.com", value: "Facebook" },
      { id: "instagram.com", value: "Instagram" },
      { id: "linkedin.com", value: "LinkedIn" },
      { id: "twitter.com", value: "Twitter" },
    ]);
    let search = ref("");
    const paraHeight = ref([]);
    let companiesImpData = ref({});
    const imagePath = ref("https://www.competiscan.com/productImg.php?cid=");
    const eachRow = ref();
    const headers = ref([
      {
        title: "Sort By",
        sortable: false,
        key: "sort_by",
      },
      {
        title: "Headline",
        sortable: true,
        key: "headline",
      },
      {
        title: "Company",
        sortable: true,
        key: "company",
      },
      {
        title: "Entry ID",
        sortable: true,
        key: "entryid",
      },
      {
        title: "A",
        sortable: true,
        key: "digital",
      },
      {
        title: "S",
        sortable: true,
        key: "panelistscore",
      },
      {
        title: "G",
        sortable: true,
        key: "animation",
      },
    ]);
    // const results = ref([]);
    const newdata = ref([]);
    const pageData = ref();
    const logoPath = ref("../assets/logo.png");
    const imageNotfound = ref("../assets/imageNotFound.gif");
    const newTabData = ref();
    const isHovering = ref(false);
    const isWrenchIconStatus = ref(false);
    const openTabContent = ref(`

   `);
    const paginationPayload = ref([]);
    const offSetTop = ref(0);
    const companyDataSend = ref([]);
    const headlineOpenwindow = ref(false);
    const downIcon = ref("mdi-menu-down");
    const upIcon = ref("mdi-menu-up");
    const showModal = ref(false);
    const closePreviewBox = ref(false);
    const searchResultData = ref();
    const timeTaken = ref();
    const totalRecords = ref();
    const pageCount = ref();
    const snackbar = ref(true);
    const totalPages = ref(); // Total number of pages
    const pagesToShow = ref(10); // Number of pages to show at a time
    const wrenchIconWhite = ref("../assets/settings-anotation.png");
    const categories = ref([]);
    const subCategories = ref([]);
    const subSubCategories = ref([]);
    const productDetailPayload = ref([]);
    const allproductId = ref([]);
    const tableRef = ref(null);
    const pdfHoverLoader = ref(false);
    const pdfHoverPop = ref(false);
    const offerOrigin = ref(store.getters["Sector/getOfferOrigin"]);
    const currentPID = ref();
    const loaderGIF = ref("../assets/searching.gif");
    const db = ref([]);
    const img = ref(new Image());
    const previewIMG = ref();
    const openProductDetatilForm = ref(null);
    const catIdSelectedLastSearch = ref();
    const responseMFlagRest = ref(false);
    onMounted(async () => {
      window.addEventListener("resize", setStickyHeader);
      let wasLastSearchFNCalledStatus = VueCookies.get("callLastSearch");
      let wasLastResultFNCalledStatus = VueCookies.get("callLastResult");

      if (wasLastSearchFNCalledStatus) {
        lastSearchAPI();
      }
      if (wasLastResultFNCalledStatus) {
        lastResultAPI();
      }
    });
    watch(actioPayload, () => {
      setSearchCriteria();
    });

    watchEffect(() => {
      newdata.value = [];
      isSearchAgainFlag.value = store.getters["Rawdata/getSearchAgainFlag"];
      // console.log(isSearchAgainFlag.value, "reset");
      let searchCriteriaLastSearch = store.getters["Rawdata/getSearchCriteria"];
      if (Object.keys(searchCriteriaLastSearch).length > 0) {
        setSearchCriteria();
      }
      if (isSearchAgainFlag.value) {
        store.dispatch("Rawdata/setSearchAgainFlag", false);
        sortingIcon.value.headline = "";
        sortingIcon.value.company = "";
        sortingIcon.value.entry = "mdi-menu-down";
        sortingIcon.value.a = "";
        sortingIcon.value.s = "";
        sortingIcon.value.g = "";
        page.value = 1;
      }
      searchResultData.value = store.getters["Rawdata/getsearchResultGetters"];
      // console.log(props.sendingWidth);
      props.sendingWidth !== null
        ? (DataTableWidth.value = props.sendingWidth)
        : (DataTableWidth.value = "100%");
      // snackbar.value = store.getters["Rawdata/getSnackbarFlagGetters"];
      // console.log("se", searchResultData.value.results);

      // console.log(Math.ceil(searchResultData.value.total_records / 10));
      // pageCount.value = Math.ceil(searchResultData.value.total_records / 10);
      if (searchResultData.value?.pages?.length > 0) {
        dataStatus.value = true;
        totalPages.value = searchResultData.value?.pages.length;
        pageCount.value = searchResultData.value.total_pages;
        pageData.value = searchResultData.value.pages;
        setStickyHeader();
        // console.log(searchResultData.value.pages.length, " ppp");
        // maxPgNum.value = searchResultData.value.pages.length
        searchResultData.value?.pages?.forEach((item) => {
          if (item.pg_no > maxPgNum.value) {
            maxPgNum.value = item.pg_no;
          }
        });
        //console.log(displayedPages, "displayedPages");
      }
      img.value.onload = function (val) {
        img.value.height = val.height;
        img.value.width = val.width;
      };
      img.value.src = notfoundImage;
      // window.onscroll = function () {
      //   // Check if the user has scrolled to the bottom
      //   if (isAtBottom()) {
      //     console.log("At the bottom of the page!");
      //   }
      // };
      // const height = paragraph.getBoundingClientRect().height;
      // console.log("par:", myParagraph.value);
      // console.log("pagesToShow", pagesToShow.value);
      // console.log("page", page.value);
      // console.log("totalPages", totalPages.value);
      // console.log(pageData.value, "page");
      // let count = 0;
      // let p = page.value;

      // const startPage = Math.max(
      //   page.value - Math.floor(pagesToShow.value / 2),
      //   1
      // );
      // const endPage = Math.min(startPage + pagesToShow.value - 1, totalPages);
      // for (let i = startPage; i <= endPage; i++) {
      //   if (i === page.value) {
      //     limitPages.value;
      //   }
      // }

      if (myParagraph.value) {
        Object.keys(myParagraph.value).forEach(function (key) {
          // console.log(myParagraph.value[key].clientHeight);
          paraHeight.value.push(myParagraph.value[key].clientHeight);
        });
      }

      // if (pageData.value) {
      //   // let p = page.value;
      //   if (diffValuesInPages.value === 5) {
      //     for (let i = 1; i < oldPagesData.value.length; i++) {
      //       if (count <= 10) {
      //         limitPages.value.push(oldPagesData.value[i]);
      //         count += 1;http://localhost:8082/
      //       }
      //     }
      //   } else if (diffValuesInPages.value === 6) {
      //     for (let i = 1; i < oldPagesData.value.length; i++) {
      //       if (count <= 10) {
      //         limitPages.value.push(oldPagesData.value[i]);
      //         count += 1;
      //       }
      //     }
      //   } else {
      //     p = 0;
      //     for (let i = p; i < pageData.value.length; i++) {
      //       if (count < 10) {
      //         limitPages.value.push(pageData.value[i]);
      //         count += 1;
      //       }
      //     }
      //   }
      // }
      // i loop temp obj and push records from pgno-3 to pgno+7 into limitpages obj
      // console.log(Object.keys(pageData.value).length, "pageData");

      timeTaken.value = searchResultData.value.time_taken?.toFixed(2);
      totalRecords.value = searchResultData.value.total_records;
      actioPayload.value = store.getters["Rawdata/getActionPayload"];
      if ("dts_val" in actioPayload.value) {
        highlight(actioPayload.value.dts_val);
      } else if ("product_headline" in actioPayload.value) {
        highlight(actioPayload.value.product_headline);
      }
      //setSearchCriteria();
    });
    // setSearchCriteria();

    watchPostEffect(() => {
      // console.log("pdfHoverLoader", pdfHoverLoader.value);
      searchResultData.value = store.getters["Rawdata/getsearchResultGetters"];
      let data = Object.keys(searchResultData.value);
      let len = 0;
      if (data) {
        len = data.length;
      }
      if (len > 0) {
        // console.log(searchResultData.value, "res");
        resultObjFormatting(searchResultData.value.results);
        // console.log("first", newdata.value);
        //callapi(page.value);
      }
    });
    // function isAtBottom() {
    //   // Get the current scroll position
    //   var scrollTop = window.pageYOffset || document.documentElement.scrollTop;

    //   // Get the total height of the document
    //   var totalHeight = document.documentElement.scrollHeight;

    //   // Get the viewport height
    //   var viewportHeight =
    //     window.innerHeight || document.documentElement.clientHeight;

    //   // Check if the user has scrolled to the bottom (with a small buffer)
    //   return scrollTop >= totalHeight - viewportHeight;
    // }

    function resultObjFormatting(apidataresult) {
      // console.log(apidataresult, "apidataresult");
      const mpanel_id_inc = [1, 2];
      apidataresult?.forEach((t) => {
        filterPrimaryAndAdditionalCompanies(t.primary_company_name, t.company);
        allproductId.value.push(t.product_id);
        const d1 = Date.parse(t.approved_date);
        const d2 = Date.parse("2020-12-01 00:00:00");
        // console.log(
        //   "apires.",
        //   t.mpanel_id,
        //   mpanel_id_inc.includes(t.mpanel_id)
        // );
        let htmlShow = false;
        if (
          t.mchanne_id === 3 &&
          mpanel_id_inc.includes(t.mpanel_id) &&
          d1 >= d2
        ) {
          // console.log(
          //   "apires",
          //   t.mchanne_id,
          //   mpanel_id_inc.includes(t.mpanel_id),
          //   t.electronic_id[0],
          //   d1 >= d2,
          //   t.primary_company_name
          // );
          htmlShow = true;
        } else {
          htmlShow = false;
        }
        // let media = store.getters["Rawdata/getmediaAPIPayloadGetters"];
        // let audience = store.getters["Rawdata/getaudienceAPIPayloadGetters"];
        // audience ids checking for wrench icon
        // let audIDS = [1, 2];
        // let mediaLogicExistence = false;

        // let audienceLogicExistence = false;

        // if (t.mchannel_name === "Email") {
        //   mediaLogicExistence = true;

        //   // audienceLogicExistence = [1, 2].some(audience[a]);
        // }
        // if (t.audience_name === "Consumer" && t.audience_name === "Consumer") {
        //   audienceLogicExistence = true;

        //   // audienceLogicExistence = [1, 2].some(audience[a]);
        // }
        // media ids checking for wrench icon
        // mediaLogicExistence = media.includes(3);
        // console.log("mediaLogicExistence", mediaLogicExistence);
        // console.log("audienceLogicExistence", audienceLogicExistence);
        // console.log("wrench", t);
        // console.log("apires", t.sector_categories.category.toString());
        // console.log("apires", t.sector_categories?.sub_category?.toString());
        sortCategories(t.sector_categories?.category, "cat");
        sortCategories(t.sector_categories?.sub_category, "sub_cat");
        sortCategories(t.sector_categories?.sub_sub_category, "sub_sub_cat");
        let keyVal =
          t.mchannel_name == "Email" ? t.mchannel_name + "2" : t.mchannel_name;
        newdata.value.push({
          ["image"]: companiesImpData.value.primaryCompanyId,
          ["ProductId"]: t.product_id,
          ["isWrench"]: t.is_annotated,
          ["isAnimation"]: htmlShow,
          ["headline"]: t.product_headline,
          ["MediaChannel"]: t.mchannel_name,
          ["Audience"]: t.audience_name,
          ["companyName"]: t.primary_company_name,
          ["additionalCompanies"]:
            companiesImpData.value.additionalCompanyName.join("; "),
          ["hideAdditionalCompanies"]: t.company_names.length > 1, //this one will show if additional company exist or not
          ["sectorName"]: collateSectorNames(t.sector_id),
          ["EntryID"]: t.entry_id,
          ["hrefVal"]: `https://cs.uat.competiscan.com/addproduct/v2/${t.product_id}?ec_content_type=${channelMap.value[keyVal]}`,
          ["Category"]: !categories.value
            ? categories.value.toString()
            : (categories.value = ""),
          ["SubCategory"]: subCategories.value.toString(),
          ["SubSubCategory"]: subSubCategories.value.toString(),
        });
      });
      // console.log("allproductId.value", allproductId.value);
      fileSizes(allproductId.value);
      previewLoadingFetch(allproductId.value);
      getMuidHandler(allproductId.value);
      isLoading.value = false;
      // console.log(12, newdata.value);
    }

    function getWrenchHandler(muid) {
      // console.log(muid, "muid");
      const url = `https://vat.competiscan.com/display/${muid}`;
      window.open(url, "_blank");
    }
    function setSearchCriteria() {
      let sortOrder = {
        ocr: 0,
        full: 0,
        "Media Channel": 0,
        Sectors: 0,
        Audience: 0,
        "Added to database": 0,
        "Approved Date": 0,
        "Panelist ID": 0,
        Panelists: 0,
        Country: 0,
        Company: 0,
        "Product Name": 0,
        "Affinity/Association ": 0,
        Related: 0,

        Primary: 0,
        "Sub Sub Category": 0,
        Reloadable: 0,
        "Application Type": 0,
        "Introductory Pricing": 0,
        "Issue Type": 0,
        "Mailing Type": 0,
        Personalization: 0,
        "Business Content": 0,
        "DMA®": 0,
        "EDC / LDC / TDSP": 0,
        "State/Province": 0,
        Age: 0,
        Income: 0,
        "Income Producing Assets Segment Code *R*": 0,
        "Value Score": 0,
        FicoScore: 0,
        CreditVision: 0,
        VantageScore: 0,
        "Worksite/Voluntary": 0,
        "Credit Union": 0,
        "Affinity/Association": 0,
        "Affinity/Association Category": 0,
        "Affinity/Association Sub-Category": 0,
        Rewards: 0,
        "Rewards Program Emphasis": 0,
        Incentive: 0,
        Rx: 0,
        Affinion: 0,
        "CDHP/HDHP/HSA": 0,
        "Pre-Screen/Opt-Out": 0,
        "Retail Card Study": 0,
        "Credit Card Mentioned": 0,
        "Target Markets": 0,
        "Fee Product": 0,
        "Faux Check": 0,
        "Ancillary Products": 0,
        "General Mortgage & Loan Details": 0,
        "Minimum Loan Amount ($)": 0,
        "Maximum Loan Amount ($)": 0,
        Riders: 0,
        "Communication Type": 0,
        "Delivery Method": 0,
        "Delivery Type": 0,
        Postage: 0,
        "Pre-Sorted": 0,
        "Postage Type": 0,
        "Electronic Type": 0,
        "Publication Type": 0,
        "Publication Name": 0,
        "Group Size": 0,
        "Offer Origin": 0,
        "Campaign Language": 0,
        "Energy - Rate Type": 0,
        "Offer Price (¢ per kWh)": 0,
        "Energy - Term Length": 0,
        "Cancel Fee": 0,
        "Face Amount": 0,
        "Term Length": 0,
        "Response Mechanism": 0,
        "Card Network": 0,
        "Network Name": 0,
        "Social Media Ad Type": 0,
      };
      let localSearchCriteria = [];
      searchCriteria.value = [];
      localSearchCriteria = { ...store.getters["Rawdata/getSearchCriteria"] };
      // searchCriteria.push(localSearchCriteria);
      // console.log("appas.", Object.keys(localSearchCriteria));
      for (let i = 0; i < Object.keys(localSearchCriteria).length; i++) {
        sortOrder[`${Object.keys(localSearchCriteria)[i]}`] =
          Object.values(localSearchCriteria)[i];
      }
      searchCriteria.value.push({ ...sortOrder });
      store.dispatch(
        "Rawdata/setsearchCriteriaGlobalAction",
        searchCriteria.value
      );

      // console.log("searchCri", searchCriteria.value[0]);
    }

    function previewLoadingFetch(pid) {
      // console.log(pid.join(), "pid");
      const apiUrl = `${
        http.value.product
      }imagelist?product_type=ProductImg&product_id=${pid.join()}`;

      fetch(apiUrl).then((response) => {
        response.json().then((data) => {
          // console.log(data, "preview");
          pdfHoverData.value = data.payload;
        });
      });
    }

    function closePreviewBoxFn() {
      let elementsArray = document.getElementsByClassName("popup-pdf");
      Object.entries(elementsArray).forEach((p) => {
        // console.log(p[1].style.display, "disp");
        p[1].style.display = "none";
      });
      // console.log(elementsArray);
      // console.log(elementsArray, "el");
    }

    function delayFn(pid) {
      // console.log("pdfHoverPop", pdfHoverPop.value);
      // console.log("allproductId.value", allproductId.value);
      currentPID.value = pid;
      pdfHoverPop.value = false;
      setTimeout(() => {
        showpdfPreview(pid);
      }, 500);
    }

    //now need to remove last cookie
    function lastResult() {
      // isLoading.value = true;
      // VueCookies.set("callLastSearch");
      // setCookie("callLastResult", null, 30, null);
      if (VueCookies.get("callLastResult")) {
        VueCookies.remove("callLastResult");
        if (VueCookies.get("callLastSearch")) {
          VueCookies.remove("callLastSearch");
        }
        lastResultAPI();
      } else {
        // VueCookies.set("callLastSearch", "callLastSearchFunction");
        setCookie("callLastResult", null, 30, null);
        if (VueCookies.get("callLastSearch")) {
          VueCookies.remove("callLastSearch");
        }
        window.location.reload();
      }
    }

    function lastResultAPI() {
      // isLoading.value = true;
      let userid = VueCookies.get("user_id");
      fetch(`${http.value.emailaleart}elasticsearch/${userid}`).then(
        (response) =>
          response.json().then((data) => {
            console.log(1, data);
            // store.dispatch("Rawdata/setSearchCritertia", data.payload);
            store.dispatch("Rawdata/setActionPayload", data.payload);
            store.dispatch("Rawdata/setsearchResultAction", data.response);
            resultObjFormatting(data.response.results);
            //isLoading.value = false;
          })
      );
      lastSearchAPI(); //this will update data selection to fields
    }
    function setCookie(cookieName, cookieValue, expirationDays, domain) {
      const date = new Date();
      date.setTime(date.getTime() + expirationDays * 60 * 1000); // Calculate expiration time in milliseconds
      const expires = "expires=" + date.toUTCString();
      const cookieDomain = domain ? `;domain=${domain.slice(7)}` : "";
      document.cookie =
        cookieName +
        "=" +
        cookieValue +
        ";" +
        expires +
        ";path=/" +
        cookieDomain;
    }

    function lastSearch() {
      // isLoading.value = true;
      if (VueCookies.get("callLastSearch")) {
        VueCookies.remove("callLastSearch");
        if (VueCookies.get("callLastResult")) {
          VueCookies.remove("callLastResult");
        }
        lastSearchAPI();
      } else {
        // VueCookies.set("callLastSearch", "callLastSearchFunction");
        setCookie("callLastSearch", null, 30, null);
        if (VueCookies.get("callLastResult")) {
          VueCookies.remove("callLastResult");
        }
        window.location.reload();
      }
    }

    function lastSearchAPI() {
      let userid = VueCookies.get("user_id"); //this will show search result for users
      // console.log("userid mainfield");
      isLoading.value = true;
      //window.location.reload();
      store.dispatch("Media/setlastSearchTriggerredAction", true);
      let apidata = {
        sortby: "entry_id_sort, desc",
        tiebreaker: "product_id, desc",
        product_status: "1",
        page_type: 1,
        mchanne_id: [],
        sector_id: [],
        mpanel_id: [],
      };
      fetch(`${http.value.emailaleart}saveresult/${userid}`).then((response) =>
        response.json().then((data) => {
          console.log(2, data);
          // media channel data
          if (data.mChannelID) {
            mediaChannel(data.mChannelID.split(","));
            Object.keys(apidata).find((key) => {
              if (key === "mchanne_id")
                apidata["mchanne_id"] = data.mChannelID.split(",");
            });
          }
          // sector data
          if (data.sectorID) {
            sectors(data.sectorID.split(","));
            Object.keys(apidata).find((key) => {
              if (key === "sector_id")
                apidata["sector_id"] = data.sectorID.split(",");
            });
          }
          // audience data
          if (data.mPanelID) {
            audiences(data.mPanelID.split(","));
            Object.keys(apidata).find((key) => {
              if (key === "mpanel_id")
                apidata["mpanel_id"] = data.mPanelID.split(",");
            });
          }
          // ocr fulltext data
          if (data.searchType) {
            let obj = {};
            obj = {
              searchKey: data.searchKey,
              searchKey2: data.searchKey2,
              searchName: data.searchName,
              searchOption: data.searchOption,
              searchType: data.searchType,
              search_type_and: data.search_type_and,
            };
            store.dispatch("Rawdata/setOcrFullTextSearch", obj);
          }
          // date dropdown data
          if (data.addedToDatabase) {
            store.dispatch("Rawdata/setsearchDateSelection", {
              dropdownDate: data.addedToDatabase,
            });
          }
          // two months dropdown data
          if (data.month1 && data.month2) {
            let obj = [];
            obj.push(data.month1);
            obj.push(data.month2);
            store.dispatch("Rawdata/setsearchDateSelection", {
              dropdownStart: obj,
            });
          }
          // months and time dropdown data approved date
          if (data.approved_date && data.approved_date_to) {
            let temp = [];
            temp.push(data.approved_date.slice(0, 10));
            temp.push(data.approved_date.slice(11, 19));
            temp.push(data.approved_date_to.slice(0, 10));
            temp.push(data.approved_date_to.slice(11, 19));
            store.dispatch("Rawdata/setsearchDateSelection", {
              approvedDate: temp,
            });
          }
          if (data.search_competi_id) {
            store.dispatch("Rawdata/setsearchDateSelection", {
              panelists: data.search_competi_id,
            });
          }
          if (data.pcountry) {
            store.dispatch("Rawdata/setsearchDateSelection", {
              country: data.pcountry,
            });
          }
          if (data.company) {
            companyHandlingFn(data.company.split("or").map((a) => a.trim()));
            store.dispatch("Rawdata/setsearchDateSelection", {
              company: data.company,
            });
          }
          if (data.company) {
            store.dispatch("Rawdata/setsearchDateSelection", {
              company: data.company,
            });
          }
          if (data.affinity_association) {
            store.dispatch("Rawdata/setsearchDateSelection", {
              affinity_association: data.affinity_association,
            });
          }
          if (data.productName) {
            store.dispatch("Rawdata/setsearchDateSelection", {
              productName: data.productName,
            });
          }
          if (data.categoryID) {
            categoriesLastSearchFunction(data.categoryID.split(","));
            apidata["cat_"] = data.categoryID.split(",");
          }
          if (data.subCategoryID) {
            subcategories(data.subCategoryID.split(","));
            apidata["cat_sub"] = data.categoryID.split(",");
          }
          if (data.subSubCategoryID) {
            subsubcategories(data.subSubCategoryID.split(","));
            apidata["cat_ssub"] = data.categoryID.split(",");
          }

          if (data.electronicID_mult) {
            electronicIDFN(data.electronicID_mult.split(","));
            Object.keys(apidata).find((key) => {
              if (key === "electronic_id")
                apidata["electronic_id"] = data.electronicID_mult.split(",");
            });
          }

          if (data.CardNetwork_mult) {
            CardNetwork_multFN(data.CardNetwork_mult.split(","));
            Object.keys(apidata).find((key) => {
              if (key === "CardNetwork_mult")
                apidata["CardNetwork_mult"] = data.CardNetwork_mult.split(",");
            });
            // console.log(apidata, "card apidata");
          }
          if (data.responseMechID_mult) {
            responseMechID_multFN(data.responseMechID_mult.split(","));
            Object.keys(apidata).find((key) => {
              if (key === "responseMechID_mult")
                apidata["responseMechID_mult"] =
                  data.responseMechID_mult.split(",");
            });
          }

          if (data.FeeProductType) {
            FeeProductTypeFN(data.FeeProductType.split(","));
            Object.keys(apidata).find((key) => {
              if (key === "FeeProductType")
                apidata["FeeProductType"] = data.FeeProductType.split(",");
            });
          }

          //rewards
          if (data.RewardsProgramEmphasis_mult) {
            RewardsProgramEmphasisFN(
              data.RewardsProgramEmphasis_mult.split(",")
            );
            Object.keys(apidata).find((key) => {
              if (key === "RewardsProgramEmphasis_mult")
                apidata["RewardsProgramEmphasis_mult"] =
                  data.RewardsProgramEmphasis_mult.split(",");
            });
          }

          //affinoity checkk and dropdown
          if (
            data.affinityAssociation ||
            data.AffinityCategoryID_mult ||
            data.AffinitySubCategoryID_mult
          ) {
            affinityAssociationFN(
              data.affinityAssociation,
              data.AffinityCategoryID_mult.split(","),
              data.AffinitySubCategoryID_mult.split(",")
            );
            Object.keys(apidata).find((key) => {
              if (key === "affinityAssociation")
                apidata["affinityAssociation"] =
                  data.affinityAssociation.split(",");
              if (key === "AffinityCategoryID_mult")
                apidata["AffinityCategoryID_mult"] =
                  data.AffinityCategoryID_mult.split(",");
              if (key === "AffinitySubCategoryID_mult")
                apidata["AffinitySubCategoryID_mult"] =
                  data.AffinitySubCategoryID_mult.split(",");
            });
          }
          //minmax slider
          if (data.minmaxmortgage) {
            let formatdata = data.minmaxmortgage.split("-");
            store.dispatch("Sector/setLoanAmount", formatdata);
          }
          //states
          if (data.state) {
            stateFN(data.state.split(","));
            Object.keys(apidata).find((key) => {
              if (key === "state") apidata["state"] = data.state.split(",");
            });
          }
          //age
          if (data.age) {
            ageFN(data.age.split(","));
            Object.keys(apidata).find((key) => {
              if (key === "age") apidata["age"] = data.age.split(",");
            });
          }
          //inc
          if (data.income_mult) {
            income_multFN(data.income_mult.split(","));
            Object.keys(apidata).find((key) => {
              if (key === "income_mult")
                apidata["income_mult"] = data.income_mult.split(",");
            });
          }
          //fico
          if (data.fico_score) {
            fico_scoreFN(data.fico_score.split(","));
            Object.keys(apidata).find((key) => {
              if (key === "fico_score")
                apidata["fico_score"] = data.fico_score.split(",");
            });
          }

          //cre vis
          if (data.credit_vision_score) {
            credit_vision_scoreFN(data.credit_vision_score.split(","));
            Object.keys(apidata).find((key) => {
              if (key === "credit_vision_score")
                apidata["credit_vision_score"] =
                  data.credit_vision_score.split(",");
            });
          }

          //income producing
          if (data.Income_Producing_Assets_Segment_Code_mult) {
            Income_Producing_Assets_Segment_Code_FN(
              data.Income_Producing_Assets_Segment_Code_mult.split(",")
            );
            Object.keys(apidata).find((key) => {
              if (key === "Income_Producing_Assets_Segment_Code_mult")
                apidata["Income_Producing_Assets_Segment_Code_mult"] =
                  data.Income_Producing_Assets_Segment_Code_mult.split(",");
            });
          }
          //vantage
          if (data.vantage_score) {
            vantage_scoreFN(data.vantage_score.split(","));
            Object.keys(apidata).find((key) => {
              if (key === "vantage_score")
                apidata["vantage_score"] = data.vantage_score.split(",");
            });
          }

          //ApplicationType_mult
          if (data.ApplicationType_mult) {
            ApplicationType_multFN(data.ApplicationType_mult.split(","));
            Object.keys(apidata).find((key) => {
              if (key === "ApplicationType_mult")
                apidata["ApplicationType_mult"] =
                  data.ApplicationType_mult.split(",");
            });
          }
          //Publication
          if (data.pubTypeID_mult) {
            pubTypeID_multFN(data.pubTypeID_mult.split(","));
            Object.keys(apidata).find((key) => {
              if (key === "pubTypeID_mult")
                apidata["pubTypeID_mult"] = data.pubTypeID_mult.split(",");
            });
          }
          //mailing type
          if (data.mTypeID) {
            MailingTypeFN(data.mTypeID.split(","));
            Object.keys(apidata).find((key) => {
              if (key === "mTypeID")
                apidata["mTypeID"] = data.mTypeID.split(",");
            });
          }
          //DMA
          if (data.DMA_ID_mult) {
            DMA_ID_multFN(data.DMA_ID_mult.split(","));
            Object.keys(apidata).find((key) => {
              if (key === "DMA_ID_mult")
                apidata["DMA_ID_mult"] = data.DMA_ID_mult.split(",");
            });
          }
          //value score
          if (data.value_score) {
            value_scoreFN(data.value_score.split(","));
            Object.keys(apidata).find((key) => {
              if (key === "value_score")
                apidata["value_score"] = data.value_score.split(",");
            });
          }
          //offer origin
          if (data.offerOrigin) {
            let obj = store.getters["Rawdata/getofferOriginChanged"];

            for (let i = 0; i < obj.length; i++) {
              if (obj[i].oo_id === Number(data.offerOrigin)) {
                // console.log(obj[i], 22, data.external_link)
                // obj[i].id;
                store.dispatch("Media/setAdditionalSelectedDataAction", {
                  offerOrigin: obj[i],
                });
                const searchCry = {
                  val: obj[i].oo_id,
                  column: "Offer Origin",
                  entirs: obj,
                };
                store.dispatch("Rawdata/setSearchSingleCritertia", searchCry);
              }
            }
          }
          //face amount
          if (data.fa_id_mult) {
            faceAmountFN(data.fa_id_mult.split(","));
            Object.keys(apidata).find((key) => {
              if (key === "fa_id_mult")
                apidata["fa_id_mult"] = data.fa_id_mult.split(",");
            });
          }
          //rider
          if (data.riders_mult) {
            riders_multFN(data.riders_mult.split(","));
            Object.keys(apidata).find((key) => {
              if (key === "riders_mult")
                apidata["riders_mult"] = data.riders_mult.split(",");
            });
          }
          //issue
          if (data.IssueTypeID_mult) {
            IssueTypeID_multFN(data.IssueTypeID_mult.split(","));
            Object.keys(apidata).find((key) => {
              if (key === "IssueTypeID_mult")
                apidata["IssueTypeID_mult"] = data.IssueTypeID_mult.split(",");
            });
          }
          //IntroPricing_mult
          if (data.IntroPricing_mult) {
            IntroPricing_multFN(data.IntroPricing_mult.split(","));
            Object.keys(apidata).find((key) => {
              if (key === "IntroPricing_mult")
                apidata["IntroPricing_mult"] =
                  data.IntroPricing_mult.split(",");
            });
          }
          //postageId
          if (data.postageId) {
            postageIdFN(data.postageId.split(","));
            Object.keys(apidata).find((key) => {
              if (key === "postageId")
                apidata["postageId"] = data.postageId.split(",");
            });
          }
          //businessContent_mult
          if (data.businessContent_mult) {
            businessContent_multFN(data.businessContent_mult.split(","));
            Object.keys(apidata).find((key) => {
              if (key === "businessContent_mult")
                apidata["businessContent_mult"] =
                  data.businessContent_mult.split(",");
            });
          }
          //communication
          if (data.agentCommunicationID) {
            agentCommunicationIDFN(data.agentCommunicationID.split(","));
            Object.keys(apidata).find((key) => {
              if (key === "agentCommunicationID")
                apidata["agentCommunicationID"] =
                  data.agentCommunicationID.split(",");
            });
          }
          //delivery method
          if (data.delmethid_mult) {
            delmethid_multFN(data.delmethid_mult.split(","));
            Object.keys(apidata).find((key) => {
              if (key === "delmethid_mult")
                apidata["delmethid_mult"] = data.delmethid_mult.split(",");
            });
          }
          //publicationNAme
          if (data.publication_name) {
            publicationNameFun(data.publication_name);
          }
          //delivery
          if (data.deliveryTypeId) {
            deliveryTypeIdFN(data.deliveryTypeId.split(","));
            Object.keys(apidata).find((key) => {
              if (key === "deliveryTypeId")
                apidata["deliveryTypeId"] = data.deliveryTypeId.split(",");
            });
          }
          //postage
          if (data.postageId) {
            postageIdFN(data.postageId.split(","));
            Object.keys(apidata).find((key) => {
              if (key === "postageId")
                apidata["postageId"] = data.postageId.split(",");
            });
          }
          //pre sorted
          if (data.presortedId) {
            presortedIdFN(data.presortedId.split(","));
            Object.keys(apidata).find((key) => {
              if (key === "presortedId")
                apidata["presortedId"] = data.presortedId.split(",");
            });
          }
          //group
          if (data.groupSize) {
            groupSizeFN(data.groupSize.split(","));
            Object.keys(apidata).find((key) => {
              if (key === "groupSize")
                apidata["groupSize"] = data.groupSize.split(",");
            });
          }
          //energy rate
          if (data.ERateType_mult) {
            ERateType_multFN(data.ERateType_mult.split(","));
            Object.keys(apidata).find((key) => {
              if (key === "ERateType_mult")
                apidata["ERateType_mult"] = data.ERateType_mult.split(",");
            });
          }
          //offer
          if (data.EOfferPrice_mult) {
            EOfferPrice_multFN(data.EOfferPrice_mult.split(";"));
            Object.keys(apidata).find((key) => {
              if (key === "EOfferPrice_mult")
                apidata["EOfferPrice_mult"] = data.EOfferPrice_mult.split(";");
            });
          }
          //energy term
          if (data.ETermLength_mult) {
            ETermLength_multFN(data.ETermLength_mult.split(","));
            Object.keys(apidata).find((key) => {
              if (key === "ETermLength_mult")
                apidata["ETermLength_mult"] = data.ETermLength_mult.split(",");
            });
          }
          if (data.compaignLanguage) {
            let camp = 0;
            let storeData = store.getters["Rawdata/getDropdownDataAPI"];
            let rawCampaign = storeData.campaign_language;
            for (let i = 0; i < rawCampaign.length; i++) {
              if (rawCampaign[i].text_value === data.compaignLanguage) {
                store.dispatch("Media/setAdditionalSelectedDataAction", {
                  camp: rawCampaign[i],
                });
              }
            }
            //  console.log(camp, "camp");
            const searchCry = {
              val: camp,
              column: "Campaign Language",
              entirs: rawCampaign,
            };
            //console.log(searchCry, "searchCrcampy");
            store.dispatch("Rawdata/setSearchSingleCritertia", searchCry);
          }
          //network
          if (data.external_link) {
            for (let i = 0; i < networkName.value.length; i++) {
              if (networkName.value[i].id === data.external_link) {
                // console.log(networkName.value[i], 22, data.external_link);
                // networkName.value[i].id;
                store.dispatch("Media/setAdditionalSelectedDataAction", {
                  external_link: networkName.value[i],
                });
                store.dispatch(
                  "Rawdata/setnetworkNamePayloadAction",
                  networkName.value[i].id
                );
                const searchCry = {
                  val: networkName.value[i].id,
                  column: "Network Name",
                  entirs: networkName.value,
                };
                store.dispatch("Rawdata/setSearchSingleCritertia", searchCry);
              }
            }
          }

          //checkboxes

          //worksite
          if (data.worksiteVoluntary) {
            store.dispatch("Media/setAdditionalSelectedDataAction", {
              worksiteVoluntary: data.worksiteVoluntary,
            });
            Object.keys(apidata).find((key) => {
              if (key === "worksiteVoluntary")
                apidata["worksiteVoluntary"] =
                  data.worksiteVoluntary.split(",");
            });
          }

          //correspondent lending
          if (data.correspondent_lending) {
            store.dispatch("Media/setAdditionalSelectedDataAction", {
              correspondent_lending: data.correspondent_lending,
            });
            Object.keys(apidata).find((key) => {
              if (key === "correspondent_lending")
                apidata["correspondent_lending"] =
                  data.correspondent_lending.split(",");
            });
          }

          //credit union
          if (data.creditUnion) {
            store.dispatch("Media/setAdditionalSelectedDataAction", {
              creditUnion: data.creditUnion,
            });
            Object.keys(apidata).find((key) => {
              if (key === "creditUnion")
                apidata["creditUnion"] = data.creditUnion.split(",");
            });
          }

          //incentive
          if (data.is_incentive) {
            store.dispatch("Media/setAdditionalSelectedDataAction", {
              is_incentive: data.is_incentive,
            });
            Object.keys(apidata).find((key) => {
              if (key === "is_incentive")
                apidata["is_incentive"] = data.is_incentive.split(",");
            });
          }

          //fee
          if (data.FeeProduct) {
            store.dispatch("Media/setAdditionalSelectedDataAction", {
              FeeProduct: data.FeeProduct,
            });
            Object.keys(apidata).find((key) => {
              if (key === "FeeProduct")
                apidata["FeeProduct"] = data.FeeProduct.split(",");
            });
          }

          //finance
          if (data.refinance) {
            store.dispatch("Media/setAdditionalSelectedDataAction", {
              refinance: data.refinance,
            });
            Object.keys(apidata).find((key) => {
              if (key === "refinance")
                apidata["refinance"] = data.refinance.split(",");
            });
          }

          //retail
          if (data.is_citi) {
            store.dispatch("Media/setAdditionalSelectedDataAction", {
              is_citi: data.is_citi,
            });
            Object.keys(apidata).find((key) => {
              if (key === "is_citi")
                apidata["is_citi"] = data.is_citi.split(",");
            });
          }

          //rx
          if (data.prescription) {
            store.dispatch("Media/setAdditionalSelectedDataAction", {
              prescription: data.prescription,
            });
            Object.keys(apidata).find((key) => {
              if (key === "prescription")
                apidata["prescription"] = data.prescription.split(",");
            });
          }

          //affinion
          if (data.is_affinion) {
            store.dispatch("Media/setAdditionalSelectedDataAction", {
              is_affinion: data.is_affinion,
            });
            Object.keys(apidata).find((key) => {
              if (key === "is_affinion")
                apidata["is_affinion"] = data.is_affinion.split(",");
            });
          }

          //conventional
          if (data.conventional) {
            store.dispatch("Media/setAdditionalSelectedDataAction", {
              conventional: data.conventional,
            });
            Object.keys(apidata).find((key) => {
              if (key === "conventional")
                apidata["conventional"] = data.conventional.split(",");
            });
          }

          //fha
          if (data.fha) {
            store.dispatch("Media/setAdditionalSelectedDataAction", {
              fha: data.fha,
            });
            Object.keys(apidata).find((key) => {
              if (key === "fha") apidata["fha"] = data.fha.split(",");
            });
          }

          //is_hphsa
          if (data.is_hphsa) {
            store.dispatch("Media/setAdditionalSelectedDataAction", {
              is_hphsa: data.is_hphsa,
            });
            Object.keys(apidata).find((key) => {
              if (key === "is_hphsa")
                apidata["is_hphsa"] = data.is_hphsa.split(",");
            });
          }

          //jumbo_ncnfg
          if (data.jumbo_ncnfg) {
            store.dispatch("Media/setAdditionalSelectedDataAction", {
              jumbo_ncnfg: data.jumbo_ncnfg,
            });
            Object.keys(apidata).find((key) => {
              if (key === "jumbo_ncnfg")
                apidata["jumbo_ncnfg"] = data.jumbo_ncnfg.split(",");
            });
          }

          //usda
          if (data.usda) {
            store.dispatch("Media/setAdditionalSelectedDataAction", {
              usda: data.usda,
            });
            Object.keys(apidata).find((key) => {
              if (key === "usda") apidata["usda"] = data.usda.split(",");
            });
          }

          //va
          if (data.va) {
            store.dispatch("Media/setAdditionalSelectedDataAction", {
              va: data.va,
            });
            Object.keys(apidata).find((key) => {
              if (key === "va") apidata["va"] = data.va.split(",");
            });
          }

          //faux_check
          if (data.faux_check) {
            store.dispatch("Media/setAdditionalSelectedDataAction", {
              faux_check: data.faux_check,
            });
            Object.keys(apidata).find((key) => {
              if (key === "faux_check")
                apidata["faux_check"] = data.faux_check.split(",");
            });
          }

          //pre-screen
          if (data.is_prescreen) {
            store.dispatch("Media/setAdditionalSelectedDataAction", {
              is_prescreen: data.is_prescreen,
            });
            Object.keys(apidata).find((key) => {
              if (key === "is_prescreen")
                apidata["is_prescreen"] = data.is_prescreen.split(",");
            });
          }

          // //retail
          // if(data.is_prescreen){
          //   store.dispatch("Media/setAdditionalSelectedDataAction", {
          //     is_prescreen: data.is_prescreen,
          //       });
          //       Object.keys(apidata).find((key) => {
          //     if (key === "is_prescreen")
          //       apidata["is_prescreen"] =
          //         data.is_prescreen.split(",");
          //   });
          // }

          //social
          if (data.socialmedia_adtype) {
            let storeData = store.getters["Rawdata/getDropdownDataAPI"];
            let rawSocial = storeData.socialmedia_adtype;
            for (let i = 0; i < rawSocial.length; i++) {
              // console.log(rawSocial[i], 22, data.socialmedia_adtype)
              if (rawSocial[i].id === data.socialmedia_adtype) {
                store.dispatch("Media/setAdditionalSelectedDataAction", {
                  socialmedia_adtype: rawSocial[i],
                });
                store.dispatch(
                  "Rawdata/setsocialPayloadAction",
                  rawSocial[i].id
                );
                const searchCry = {
                  val: rawSocial[i].id,
                  column: "Social Media Ad Type",
                  entirs: rawSocial,
                };
                store.dispatch("Rawdata/setSearchSingleCritertia", searchCry);
                // console.log(searchCry, "searchCry");
              }
            }
          }
          //dma

          store.dispatch("Rawdata/setLastResultFields", data);
        })
      );
      store.dispatch("Rawdata/setActionPayload", apidata);
      isLoading.value = false;
    }

    function mediaChannel(mChannel) {
      let storeData = store.getters["Rawdata/getDropdownDataAPI"];
      if (storeData) {
        let media = storeData.mediachannel;
        // console.log(media, " med")
        let tempmedia = [];
        for (const m in media) {
          // console.log(media[m].mChannelID);
          let flag = mChannel.includes(media[m].mChannelID.toString());
          // console.log(flag)
          if (flag) {
            // console.log(flag, media[m]);
            tempmedia.push(media[m]);
          }
        }
        store.dispatch("Media/setselectedDataAction", {
          mChannelID: tempmedia,
        });
        // console.log(temp, "temp");
        const searchCry = {
          val: mChannel,
          column: "Media Channel",
          entirs: tempmedia,
        };
        store.dispatch("Rawdata/setSearchCritertia", searchCry);
      }
      mChannel.forEach((m) => {
        switchMediaFunctionCases(Number(m));
      });
      // console.log("lets check ", store.getters["Media/getselectedDataGetters"]);
    }
    function switchMediaFunctionCases(element) {
      // console.log(typeof element, "ele", element);
      let dashbBoardFlag = store.getters["Media/getDashboardBoxFlagGetters"];

      switch (element) {
        case 2:
          store.dispatch("Media/setPrintPublicationTypeBoxFlag", true);
          store.dispatch("Rawdata/setmediaAPIPayloadAction", element);
          store.dispatch("Rawdata/setSearchAPIBodyAction", { m: element });
          break;
        case 1:
          store.dispatch("Rawdata/setmediaAPIPayloadAction", element);
          store.dispatch("Media/setDeliveryDirectMailFlag", true);
          store.dispatch("Rawdata/setSearchAPIBodyAction", { m: element });
          if (dashbBoardFlag) {
            store.dispatch("Media/setDashboardDirectMailBoxFlagAction", true);
          }
          break;
        case 3:
          store.dispatch("Rawdata/setSearchAPIBodyAction", { m: element });
          store.dispatch("Rawdata/setmediaAPIPayloadAction", element);
          store.dispatch("Media/setEmailElectronicTypeBoxFlag", true);
          break;
        case 6:
          store.dispatch("Rawdata/setSearchAPIBodyAction", { m: element });
          store.dispatch("Rawdata/setmediaAPIPayloadAction", element);
          store.dispatch("Media/setSocialNetworkNameBoxFlag", true);
          break;
        case 13:
          store.dispatch("Rawdata/setSearchAPIBodyAction", { m: element });
          store.dispatch("Rawdata/setmediaAPIPayloadAction", element);
          store.dispatch("Media/setDashboardBoxFlagAction", true);
          break;
        case 5:
          store.dispatch("Rawdata/setSearchAPIBodyAction", { m: element });
          store.dispatch("Rawdata/setmediaAPIPayloadAction", element);
          break;
        case 10:
          store.dispatch("Rawdata/setSearchAPIBodyAction", { m: element });
          store.dispatch("Rawdata/setmediaAPIPayloadAction", element);
          break;
        case 9:
          store.dispatch("Rawdata/setSearchAPIBodyAction", { m: element });
          store.dispatch("Rawdata/setmediaAPIPayloadAction", element);
          break;
        case 14:
          store.dispatch("Rawdata/setSearchAPIBodyAction", { m: element });
          store.dispatch("Rawdata/setmediaAPIPayloadAction", element);
          break;
      }
    }
    function sectors(sectorid) {
      // console.log(sectorid, "sec");
      let secids = sectorid.map(Number);
      let storeData = store.getters["Rawdata/getDropdownDataAPI"];
      // console.log(storeData, "storeData");
      if (storeData) {
        let rawsectors = storeData.sectors;
        let temp = [];
        for (const s in rawsectors) {
          // console.log(s, rawsectors[s]);
          let flag = sectorid.includes(rawsectors[s].sectorID.toString());
          if (flag) {
            // console.log(flag, rawsectors[s]);
            temp.push(rawsectors[s]);
          }
        }
        store.dispatch("Media/setselectedDataAction", {
          sectorID: temp,
        });
        const searchCry = {
          val: secids,
          column: "Sectors",
          entirs: temp,
        };
        store.dispatch("Rawdata/setSearchCritertia", searchCry);
      }

      sectorHandler(secids);
      // categoriesSearch(rawsectors[s].sectorID)
      // selctdSectors.forEach((t) => {categoriesSearch(Number(t))})
      // console.log(selctdSectors, "selctdSectors");
    }

    function sectorHandler(sectorid) {
      // console.log(sectorid, "sectorid");
      let autoCreditCombo = !sectorid.includes(90);
      let mortageLoan = !sectorid.includes(6);
      let travelRetailCombo = [266, 219, 559, 560].some((i) =>
        sectorid.includes(i)
      );
      let autoBankCreditCombo = [87, 90].some((i) => sectorid.includes(i));

      if (travelRetailCombo) {
        store.dispatch(
          "Sector/setTravelRetailBoxFlagAction",
          travelRetailCombo
        );
      } else {
        store.dispatch(
          "Sector/setTravelRetailBoxFlagAction",
          travelRetailCombo
        );
      }
      // c
      if (autoBankCreditCombo) {
        store.dispatch("Sector/setBankingCardAction", autoBankCreditCombo);
      } else {
        store.dispatch("Sector/setBankingCardAction", autoBankCreditCombo);
      }
      if (!mortageLoan) {
        store.dispatch("Sector/setMortageSelectedAction", true);
      } else {
        store.dispatch("Sector/setMortageSelectedAction", false);
      }
      if (!autoCreditCombo) {
        store.dispatch("Sector/setCreditComboBoxesAction", true);
        store.dispatch("Sector/setBankCreditAction", true);
      } else {
        store.dispatch("Sector/setCreditComboBoxesAction", false);
        store.dispatch("Sector/setBankCreditAction", false);
      }
      sectorid.forEach((s) => {
        switchSectorFunctionCases(Number(s));
        offerOriginFn(Number(s), "add");
      });
    }

    function offerOriginFn(id, dis) {
      // console.log(id, dis);
      let obj = store.getters["Rawdata/getofferOriginChanged"];
      if (dis === "add") {
        for (let i = 0; i < obj.length; i++) {
          let sectors = obj[i].oo_sectorID;
          ``;
          if (sectors.includes(id)) {
            // Check for duplicates before pushing
            let found = offerOrigin.value.some(
              (item) => item.oo_id === obj[i].oo_id
            );
            if (!found) {
              offerOrigin.value.push(obj[i]);
            }
          }
        }
      }
      // console.log(offerOrigin.value, offerOrigin.value);
      store.dispatch("Sector/setOfferOrigin", offerOrigin.value);
    }
    function audiences(mPanelID) {
      // console.log(mPanelID, "mPanelID");
      let storeData = store.getters["Rawdata/getDropdownDataAPI"];
      // console.log(storeData, "storeData");
      let temp1 = mPanelID.map(Number);
      if (storeData) {
        let rawaudience = storeData.audience;
        let temp = [];
        for (const s in rawaudience) {
          let flag = mPanelID.includes(rawaudience[s].mPanelID.toString());
          if (flag) {
            // console.log(flag, media[m]);
            temp.push(rawaudience[s]);
          }
        }
        // console.log(temp, "temp");
        store.dispatch("Media/setselectedDataAction", {
          mPanelID: temp,
        });
        const searchCry = {
          val: temp1,
          column: "Audience",
          entirs: temp,
        };
        store.dispatch("Rawdata/setSearchCritertia", searchCry);
      }
      temp1.forEach((m) => {
        switchAudienceFunctionCases(m);
      });
    }

    async function switchAudienceFunctionCases(element) {
      // conso `le.log(element, typeof element, "aud ele");
      let consumerEmpBoxFlag =
        store.getters["Audience/getConsumerEmpBoxesFlagGetters"];
      let personalizedBoxFlag =
        store.getters["Audience/getpersonalizedFlagGetters"];
      let insuranceBoxFlag =
        store.getters["Audience/getInsuranceBoxFlagGetters"];
      if (!personalizedBoxFlag) {
        store.dispatch(
          "Audience/setpersonalizedFlagAction",
          !personalizedBoxFlag
        );
      }
      let commPay = {
        id: element,
        sleBox: "audience",
        status: "select",
      };
      store.dispatch("Sector/setCommunicationTypeData", commPay);

      let rawaudience = store.getters["Rawdata/getDropdownDataAPI"].audience;
      let dropdown = store.getters["Media/getselectedDataGetters"];
      if (Object.keys(dropdown).length > 0) {
        // let dropdown = store.getters["Media/getselectedDataGetters"];
        // console.log(dropdown, "drop", sectors);
        let tempAudIds = [];
        //the below will store all sectorids in one array so that i can find
        //1) create array of all sector ids tempSecIds

        for (let aud of rawaudience) {
          tempAudIds.push(aud.mPanelID);
        }
        //2) find selected sectorid in the name of element in the created array tempSecIds

        // for (let aid of rawaudience) {
        //   if (element === aid.mPanelID) {
        //     dropdown["mPanelID"].push(aid);
        //   }
        // }
      }

      // switch (element) {
      //   case 1:
      //     store.dispatch("Rawdata/setaudienceAPIPayloadAction", element);
      //     store.dispatch("Rawdata/setSearchAPIBodyAction", { a: element });
      //     if (!consumerEmpBoxFlag) {
      //       store.dispatch("Audience/setConsumerEmpBoxesFlagAction", true);
      //     } else {
      //       let status1 = !element.toString().includes(1);
      //       let status2 = !element.toString().includes(2);
      //       if (status1 && status2) {
      //         store.dispatch("Audience/setConsumerEmpBoxesFlagAction", true);
      //       }
      //     }
      //     break;
      //   case 9:
      //     store.dispatch("Rawdata/setaudienceAPIPayloadAction", element);
      //     store.dispatch("Rawdata/setSearchAPIBodyAction", { a: element });
      //     break;
      //   case 2:
      //     store.dispatch("Rawdata/setaudienceAPIPayloadAction", element);
      //     store.dispatch("Rawdata/setSearchAPIBodyAction", { a: element });
      //     if (!consumerEmpBoxFlag) {
      //       store.dispatch("Audience/setConsumerEmpBoxesFlagAction", true);
      //     } else {
      //       let status1 = !element.toString().includes(1);
      //       let status2 = !element.toString().includes(2);
      //       if (status1 && status2) {
      //         store.dispatch("Audience/setConsumerEmpBoxesFlagAction", true);
      //       }
      //     }
      //     break;
      //   case 4:
      //     store.dispatch("Rawdata/setaudienceAPIPayloadAction", element);
      //     store.dispatch("Rawdata/setSearchAPIBodyAction", { a: element });
      //     if (insuranceBoxFlag) {
      //       store.dispatch(
      //         "Audience/setInsuranceBoxFlagAction",
      //         !insuranceBoxFlag
      //       );
      //     } else {
      //       store.dispatch(
      //         "Audience/setInsuranceBoxFlagAction",
      //         !insuranceBoxFlag
      //       );
      //     }
      //     break;
      //   case 6:
      //     store.dispatch("Rawdata/setaudienceAPIPayloadAction", element);
      //     store.dispatch("Rawdata/setSearchAPIBodyAction", { a: element });
      //     break;
      //   case 5:
      //     store.dispatch("Rawdata/setaudienceAPIPayloadAction", element);
      //     store.dispatch("Rawdata/setSearchAPIBodyAction", { a: element });
      //     break;
      // }
      if (consumerEmpBoxFlag) {
        await dropApiCall(2);
        await dropApiCall(4);
        await dropApiCall(5);
      }
    }

    async function switchSectorFunctionCases(element) {
      // console.log("switch hit", element);
      // console.log(disSelect.value, "dis");
      // let rawSector = store.getters["Rawdata/getsectorAPIPayloadGetters"]; //original sector data
      // one by one sector id will be found from original and push it inside in the store variable which comes from search api
      sectorIdsSelected.value.push(element);

      let responseMech = JSON.parse(
        JSON.stringify(store.getters["Sector/getresponseMechanismAPIGett"])
      );
      let energyFlag = store.getters["Sector/getenergyBoxesFlag"];

      switch (element) {
        case 372:
          store.dispatch("Rawdata/setsectorAPIPayloadAction", element);
          await sectorsFnHandler(372, "Sector/setCategoryAction");
          store.dispatch("Rawdata/setSearchAPIBodyAction", { s: element });
          // store.dispatch("Rawdata/setsectorAPIPayloadAction", element);
          break;
        case 87:
          store.dispatch("Rawdata/setsectorAPIPayloadAction", element);
          await sectorsFnHandler(87, "Sector/setCategoryAction");
          store.dispatch("Rawdata/setSearchAPIBodyAction", { s: element });
          // store.dispatch("Rawdata/setsectorAPIPayloadAction", element);
          break;
        case 90:
          productName.value = !productName.value;
          store.dispatch("Rawdata/setSearchAPIBodyAction", { s: element });
          store.dispatch("Rawdata/setsectorAPIPayloadAction", element);
          await sectorsFnHandler(90, "Sector/setCategoryAction");
          await store.dispatch(
            "Sector/setProductNameAction",
            productName.value
          );
          break;
        case 315:
          store.dispatch("Rawdata/setSearchAPIBodyAction", { s: element });
          store.dispatch("Rawdata/setsectorAPIPayloadAction", element);
          if (energyFlag) {
            store.dispatch("Sector/setEnergyBoxesFlag", false);
          } else {
            await dropApiCall(1);
            await dropApiCall(3);
            await dropApiCall(6);
            store.dispatch("Sector/setEnergyBoxesFlag", true);
          }
          await sectorsFnHandler(315, "Sector/setCategoryAction");
          break;
        case 530:
          store.dispatch("Rawdata/setSearchAPIBodyAction", { s: element });
          store.dispatch("Rawdata/setsectorAPIPayloadAction", element);
          await sectorsFnHandler(530, "Sector/setCategoryAction");
          break;
        case 4:
          store.dispatch("Rawdata/setSearchAPIBodyAction", { s: element });
          store.dispatch("Rawdata/setsectorAPIPayloadAction", element);
          // eslint-disable-next-line no-case-declarations
          let insuranceBox = store.getters["Sector/getInsuranceBoxFlagGetters"];
          if (insuranceBox) {
            store.dispatch("Sector/setInsuranceBoxFlagAction", false);
          } else {
            store.dispatch("Sector/setInsuranceBoxFlagAction", true);
          }
          // console.log("insuranceBox", insuranceBox);
          await sectorsFnHandler(4, "Sector/setCategoryAction");
          break;
        case 5:
          // eslint-disable-next-line no-case-declarations
          store.dispatch("Rawdata/setSearchAPIBodyAction", { s: element });
          store.dispatch("Rawdata/setsectorAPIPayloadAction", element);
          // eslint-disable-next-line no-case-declarations
          let investmentBox =
            store.getters["Sector/getInvestmentBoxFlagGetters"];
          if (investmentBox) {
            store.dispatch("Sector/setInvestmentBoxFlagAction", false);
          } else {
            store.dispatch("Sector/setInvestmentBoxFlagAction", true);
          }
          await sectorsFnHandler(5, "Sector/setCategoryAction");
          break;
        case 6:
          store.dispatch("Rawdata/setSearchAPIBodyAction", { s: element });
          store.dispatch("Rawdata/setsectorAPIPayloadAction", element);
          await sectorsFnHandler(6, "Sector/setCategoryAction");
          break;
        case 513:
          store.dispatch("Rawdata/setSearchAPIBodyAction", { s: element });
          store.dispatch("Rawdata/setsectorAPIPayloadAction", element);
          await sectorsFnHandler(513, "Sector/setCategoryAction");
          break;
        case 522:
          store.dispatch("Rawdata/setSearchAPIBodyAction", { s: element });
          store.dispatch("Rawdata/setsectorAPIPayloadAction", element);
          await sectorsFnHandler(522, "Sector/setCategoryAction");
          break;
        case 266:
          store.dispatch("Rawdata/setSearchAPIBodyAction", { s: element });
          store.dispatch("Rawdata/setsectorAPIPayloadAction", element);
          await sectorsFnHandler(266, "Sector/setCategoryAction");
          for (let [key, index] in responseMech) {
            if (responseMech[key].responseMechID === 1) {
              responseMech.splice(index, 1);
            }
          }
          store.dispatch("Sector/setresponseMechanismAction", responseMech);
          break;
        case 525:
          store.dispatch("Rawdata/setSearchAPIBodyAction", { s: element });
          store.dispatch("Rawdata/setsectorAPIPayloadAction", element);
          await sectorsFnHandler(525, "Sector/setCategoryAction");
          break;
        case 9:
          store.dispatch("Rawdata/setSearchAPIBodyAction", { s: element });
          store.dispatch("Rawdata/setsectorAPIPayloadAction", element);
          await sectorsFnHandler(9, "Sector/setCategoryAction");
          break;
        case 219:
          store.dispatch("Rawdata/setSearchAPIBodyAction", { s: element });
          store.dispatch("Rawdata/setsectorAPIPayloadAction", element);
          await sectorsFnHandler(219, "Sector/setCategoryAction");
          break;
        case 559:
          store.dispatch("Rawdata/setSearchAPIBodyAction", { s: element });
          store.dispatch("Rawdata/setsectorAPIPayloadAction", element);
          await sectorsFnHandler(559, "Sector/setCategoryAction");
          break;
        case 560:
          store.dispatch("Rawdata/setSearchAPIBodyAction", { s: element });
          store.dispatch("Rawdata/setsectorAPIPayloadAction", element);
          await sectorsFnHandler(560, "Sector/setCategoryAction");
          break;
      }
    }

    async function sectorsFnHandler(id, actionName) {
      store.dispatch(
        "Sector/setOrignalCommuncationCopied",
        store.getters["Rawdata/getDropdownDataAPI"].communication_type
      );
      let cat = store.getters["Sector/getAllCategoryLocalGetters"];
      let showcatstore = store.getters["Sector/getcategorySector"];
      let showcat = [];
      let uniqueValues = new Set();
      for (let i = 0; i < Object.entries(cat).length; i++) {
        if (cat[i].pid === id) {
          showcat.push(cat[i]);
          uniqueValues.add(cat[i]);
        }
      }

      // Loop through showcatstore
      showcatstore.forEach((t) => {
        if (!uniqueValues.has(t)) {
          showcat.push(t); // Push unique values from showcatstore
          uniqueValues.add(t); // Add the unique value to the set
        }
      });
      let commPay = {
        id: id,
        sleBox: "sector",
        status: "select",
      };
      store.dispatch("Sector/setCommunicationTypeData", commPay);
      store.dispatch(actionName, showcat);
      responseMFlagInsurance.value = false;
      responseMFlagRest.value = false;
      responseMechHandler();
    }

    async function companyHandlingFn(cnames) {
      try {
        const response = await fetch(
          "http://0.0.0.0:5000/companyName_searchList",
          {
            method: "POST", // Specify the method as POST
            headers: {
              "Content-Type": "application/json", // Specify content type if sending JSON data
              // Add other headers as needed
            },
            body: JSON.stringify({ get_company: cnames }), // Include data in the body
          }
        );

        if (!response.ok) {
          throw new Error("Network response was not ok");
        }

        const data = await response.json();
        // Process the data
        console.log(data, "res");
        store.dispatch("Rawdata/setsearchDateSelection", {
          choosenCompanies: data,
        });
      } catch (error) {
        // Handle errors
        console.error("Error fetching data:", error.message);
      }
    }
    function electronicIDFN(electronic_id) {
      let storeData = store.getters["Rawdata/getDropdownDataAPI"];
      if (storeData) {
        let elec = storeData.electronic_type;
        let temp = [];
        for (const m in elec) {
          let flag = electronic_id.includes(elec[m].electronic_id.toString());
          if (flag) {
            store.dispatch("Media/setAdditionalSelectedDataAction", {
              electronicID_mult: elec[m],
            });
            temp.push(elec[m]);
          }
        }
        const searchCry = {
          val: electronic_id,
          column: "Electronic Type",
          entirs: temp,
        };
        electronic_id.forEach((e) => {
          store.dispatch("Rawdata/setelectronicTypePayloadAction", Number(e));
        });
        store.dispatch("Rawdata/setSearchCritertia", searchCry);
      }
    }

    function CardNetwork_multFN(CardNetwork_mult) {
      let storeData = store.getters["Rawdata/getDropdownDataAPI"];
      if (storeData) {
        let card = storeData.card_type;
        let temp = [];
        let temp1 = CardNetwork_mult.map(Number);
        for (const m in card) {
          let flag = temp1.includes(card[m].CardTypeID);
          if (flag) {
            temp.push(card[m]);
            store.dispatch("Media/setAdditionalSelectedDataAction", {
              CardNetwork_mult: card[m],
            });
            const pay = {
              values: CardNetwork_mult,
              boxname: "Card Network",
            };
            // console.log("WWWww", pay);
            store.dispatch("Sector/setDefaultDropdown", pay);
          }
        }
        const searchCry = {
          val: temp1,
          column: "Card Network",
          entirs: temp,
        };
        store.dispatch("Rawdata/setSearchCritertia", searchCry);
      }
    }

    function responseMechID_multFN(responseMechID_mult) {
      let storeData = store.getters["Rawdata/getDropdownDataAPI"];
      if (storeData) {
        let resp = storeData.response_machanism;
        let temp = [];
        let temp1 = responseMechID_mult.map(Number);
        for (const m in resp) {
          let flag = temp1.includes(resp[m].responseMechID);
          if (flag) {
            temp.push(resp[m]);
            store.dispatch("Media/setAdditionalSelectedDataAction", {
              responseMechID_mult: resp[m],
            });
            const pay = {
              values: responseMechID_mult,
              boxname: "Response Mechanism",
            };
            // console.log("WWWww", pay);
            store.dispatch("Sector/setDefaultDropdown", pay);
          }
        }
        const searchCry = {
          val: temp1,
          column: "Response Mechanism",
          entirs: temp,
        };
        store.dispatch("Rawdata/setSearchCritertia", searchCry);
      }
    }

    function RewardsProgramEmphasisFN(RewardsProgramEmphasis_mult) {
      const additinalRawData = store.getters["Rawdata/getRawAdditionalGetters"];
      // store.dispatch("Sector/setCheckboxPayload", true);
      // store.dispatch("Sector/setAffinityCategories", true);
      if (additinalRawData) {
        let resp = additinalRawData.rewardProgBoxData;
        // console.log(resp, "resp");
        let temp = [];
        let temp1 = RewardsProgramEmphasis_mult.map(Number);
        // console.log(temp1, "temp1")
        for (const m in resp) {
          let flag = temp1.includes(resp[m].RewardTypeID);
          // console.log(flag, "flag", resp[m])
          if (flag) {
            // temp[m] = resp[m].RewardTypeID
            // console.log(resp[m], "resp[m]");
            temp.push(resp[m]);
            store.dispatch("Media/setAdditionalSelectedDataAction", {
              RewardsProgramEmphasis_mult: resp[m].RewardTypeID,
            });
          }
        }
      }
    }

    function FeeProductTypeFN(FeeProductType) {
      let storeData = store.getters["Rawdata/getDropdownDataAPI"];
      if (storeData) {
        let anc = storeData.ancillary_product;
        let temp = [];
        let temp1 = FeeProductType.map(Number);
        for (const m in anc) {
          let flag = temp1.includes(anc[m].ancillary_id);
          if (flag) {
            temp.push(anc[m]);
            store.dispatch("Media/setAdditionalSelectedDataAction", {
              FeeProductType: anc[m],
            });
            const pay = {
              values: FeeProductType,
              boxname: "Ancillary Products",
            };
            // console.log("WWWww", pay);
            store.dispatch("Sector/setDefaultDropdown", pay);
          }
        }
        const searchCry = {
          val: temp1,
          column: "Ancillary Service - No Fee",
          entirs: temp,
        };
        store.dispatch("Rawdata/setSearchCritertia", searchCry);
      }
    }
    function stateFN(state) {
      let storeData = store.getters["Rawdata/getDropdownDataAPI"];
      if (storeData) {
        let st = storeData.states;
        let temp = [];
        let temp1 = state.map(Number);
        for (const m in st) {
          let flag = temp1.includes(st[m].stateID);
          if (flag) {
            temp.push(st[m]);
            store.dispatch("Media/setAdditionalSelectedDataAction", {
              state: st[m],
            });
            const pay = {
              values: temp1,
              boxname: "State/Province",
            };
            // console.log("WWWww", pay);
            store.dispatch("Sector/setSiDropDownPayload", pay);
          }
        }
        const searchCry = {
          val: temp1,
          column: "State/Province",
          entirs: temp,
        };
        store.dispatch("Rawdata/setSearchCritertia", searchCry);
      }
    }
    function ageFN(age) {
      let storeData = store.getters["Rawdata/getDropdownDataAPI"];
      if (storeData) {
        let ag = storeData.age_group;
        let temp = [];
        let temp1 = age.map(Number);
        for (const m in ag) {
          let flag = temp1.includes(ag[m].age_pID);
          if (flag) {
            temp.push(ag[m]);
            store.dispatch("Media/setAdditionalSelectedDataAction", {
              age: ag[m],
            });
            const pay = {
              values: temp1,
              boxname: "Age",
            };
            store.dispatch("Sector/setSiDropDownPayload", pay);
          }
        }
        const searchCry = {
          val: temp1,
          column: "Age",
          entirs: temp,
        };
        store.dispatch("Rawdata/setSearchCritertia", searchCry);
      }
    }

    function income_multFN(income_mult) {
      let storeData = store.getters["Rawdata/getDropdownDataAPI"];
      if (storeData) {
        let income = storeData.incometype;
        let temp = [];
        let temp1 = income_mult.map(Number);
        for (const m in income) {
          let flag = temp1.includes(income[m].incomeID);
          if (flag) {
            temp.push(income[m]);
            store.dispatch("Media/setAdditionalSelectedDataAction", {
              income_mult: income[m],
            });
            const pay = {
              values: temp1,
              boxname: "Income",
            };
            store.dispatch("Sector/setSiDropDownPayload", pay);
          }
        }
        const searchCry = {
          val: temp1,
          column: "Income",
          entirs: temp,
        };
        store.dispatch("Rawdata/setSearchCritertia", searchCry);
      }
    }

    function fico_scoreFN(fico_score) {
      const additinalRawData = store.getters["Rawdata/getRawAdditionalGetters"];
      let FICOCreditVantage = additinalRawData.FICO_CREDIT_VINTAGE.sort(
        (a, b) => b.id - a.id
      );
      if (additinalRawData) {
        let ficco = FICOCreditVantage;
        let temp = [];
        let temp1 = fico_score.map(Number);
        for (const m in ficco) {
          let flag = temp1.includes(ficco[m].id);
          if (flag) {
            temp.push(ficco[m]);
            store.dispatch("Media/setAdditionalSelectedDataAction", {
              fico_score: ficco[m],
            });
            const pay = {
              values: temp1,
              boxname: "FicoScore",
            };
            store.dispatch("Sector/setSiDropDownPayload", pay);
          }
        }
        const searchCry = {
          val: temp1,
          column: "FicoScore",
          entirs: temp,
        };
        store.dispatch("Rawdata/setSearchCritertia", searchCry);
      }
    }

    function vantage_scoreFN(vantage_score) {
      const additinalRawData = store.getters["Rawdata/getRawAdditionalGetters"];
      let FICOCreditVantage = additinalRawData.FICO_CREDIT_VINTAGE.sort(
        (a, b) => b.id - a.id
      );
      if (additinalRawData) {
        let vant = FICOCreditVantage;
        let temp = [];
        let temp1 = vantage_score.map(Number);
        for (const m in vant) {
          let flag = temp1.includes(vant[m].id);
          if (flag) {
            temp.push(vant[m]);
            store.dispatch("Media/setAdditionalSelectedDataAction", {
              vantage_score: vant[m],
            });
            const pay = {
              values: temp1,
              boxname: "VantageScore",
            };
            store.dispatch("Sector/setSiDropDownPayload", pay);
          }
        }
        const searchCry = {
          val: temp1,
          column: "VantageScore",
          entirs: temp,
        };
        store.dispatch("Rawdata/setSearchCritertia", searchCry);
      }
    }

    function credit_vision_scoreFN(credit_vision_score) {
      const additinalRawData = store.getters["Rawdata/getRawAdditionalGetters"];
      let FICOCreditVantage = additinalRawData.FICO_CREDIT_VINTAGE.sort(
        (a, b) => b.id - a.id
      );
      if (additinalRawData) {
        let cred = FICOCreditVantage;
        let temp = [];
        let temp1 = credit_vision_score.map(Number);
        for (const m in cred) {
          let flag = temp1.includes(cred[m].id);
          if (flag) {
            temp.push(cred[m]);
            store.dispatch("Media/setAdditionalSelectedDataAction", {
              credit_vision_score: cred[m],
            });
            const pay = {
              values: temp1,
              boxname: "CreditVision",
            };
            store.dispatch("Sector/setSiDropDownPayload", pay);
          }
        }
        const searchCry = {
          val: temp1,
          column: "CreditVision",
          entirs: temp,
        };
        store.dispatch("Rawdata/setSearchCritertia", searchCry);
      }
    }

    function Income_Producing_Assets_Segment_Code_FN(
      Income_Producing_Assets_Segment_Code_mult
    ) {
      // console.log(
      //   Income_Producing_Assets_Segment_Code_mult,
      //   "Income_Producing_Assets_Segment_Code_mult"
      // );
      //const incomeProd = store.getters["Sector/getdropDownDataIncomeProducing"];
      //console.log(incomeProd, "incomeProd");
      // if (additinalRawData) {
      //   let cred = FICOCreditVantage;
      //   let temp = [];
      //   let temp1 = credit_vision_score.map(Number);
      //   for (const m in cred) {
      //     let flag = temp1.includes(cred[m].id);
      //     if (flag) {
      //       temp.push(cred[m]);
      //       store.dispatch("Media/setAdditionalSelectedDataAction", {
      //         credit_vision_score: cred[m],
      //       });
      //       const pay = {
      //         values: temp1,
      //         boxname: "CreditVision",
      //       };
      //       store.dispatch("Sector/setSiDropDownPayload", pay);
      //     }
      //   }
      //   const searchCry = {
      //     val: temp1,
      //     column: "CreditVision",
      //     entirs: temp,
      //   };
      //   store.dispatch("Rawdata/setSearchCritertia", searchCry);
      // }
    }

    function ApplicationType_multFN(ApplicationType_mult) {
      // console.log(ApplicationType_mult, "ApplicationType_mult");
      const additinalRawData = store.getters["Rawdata/getRawAdditionalGetters"];
      let application = additinalRawData.applicationType.sort(
        (a, b) => a.ApplicationTypeSort - b.ApplicationTypeSort
      );
      if (additinalRawData) {
        let cred = application;
        let temp = [];
        let temp1 = ApplicationType_mult.map(Number);
        for (const m in cred) {
          let flag = temp1.includes(cred[m].ApplicationTypeID);
          if (flag) {
            temp.push(cred[m]);
            store.dispatch("Media/setAdditionalSelectedDataAction", {
              ApplicationType_mult: cred[m],
            });
            const pay = {
              values: temp1,
              boxname: "Application Type",
            };
            store.dispatch("Sector/setSiDropDownPayload", pay);
          }
        }
        const searchCry = {
          val: temp1,
          column: "Application Type",
          entirs: temp,
        };
        store.dispatch("Rawdata/setSearchCritertia", searchCry);
      }
    }

    function pubTypeID_multFN(pubTypeID_mult) {
      // console.log(pubTypeID_mult, "pubTypeID_mult");
      const additinalRawData = store.getters["Rawdata/getRawAdditionalGetters"];
      let publication = additinalRawData.publicationType.sort(
        (a, b) => a.print_typeSort - b.print_typeSort
      );
      if (additinalRawData) {
        let temp = [];
        let temp1 = pubTypeID_mult.map(Number);
        for (const m in publication) {
          let flag = temp1.includes(publication[m].print_typeID);
          if (flag) {
            temp.push(publication[m]);
            store.dispatch("Media/setAdditionalSelectedDataAction", {
              pubTypeID_mult: publication[m],
            });
            const pay = {
              values: temp1,
              boxname: "Publication Type",
            };
            store.dispatch("Sector/setSiDropDownPayload", pay);
          }
        }
        const searchCry = {
          val: temp1,
          column: "Publication Type",
          entirs: temp,
        };
        store.dispatch("Rawdata/setSearchCritertia", searchCry);
      }
    }

    function publicationNameFun(name) {
      let pubnames = [];
      fetch(`${http.value.vatBackend}publications/${name}`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization:
            "eyJraWQiOiJxUytUWFFjcitCXC9mK3ZBdzJ2QWl4c1hqUVZPZFRVaURrM2RIQkVlZ1hNaz0iLCJhbGciOiJSUzI1NiJ9.eyJzdWIiOiI5NDI2N2NjNC02MDViLTRhMmItOTlhZi1mMDE5MDk3NTUyODYiLCJldmVudF9pZCI6IjU2YWJlMDkzLTJjYTgtNDA1Zi1iN2NkLWUxODM0YTBkMGEyYiIsInRva2VuX3VzZSI6ImFjY2VzcyIsInNjb3BlIjoiYXdzLmNvZ25pdG8uc2lnbmluLnVzZXIuYWRtaW4iLCJhdXRoX3RpbWUiOjE2ODg0NjA3MjQsImlzcyI6Imh0dHBzOlwvXC9jb2duaXRvLWlkcC51cy13ZXN0LTIuYW1hem9uYXdzLmNvbVwvdXMtd2VzdC0yX2ZMWVVwdVBWZyIsImV4cCI6MTY4ODQ2MjUyNCwiaWF0IjoxNjg4NDYwNzI0LCJqdGkiOiIyNjhjMDY0Yy1lNWNhLTRhNTQtODQ2My0wZWIxOWY2MDEwNzIiLCJjbGllbnRfaWQiOiIyZzU0cWtxajNwbHRqcWN2ZDE4YmR2Z3F2MCIsInVzZXJuYW1lIjoiYXJ2aW5kbm1nIn0.efQRa1v2ZkzEL62JO9VEuQpglne1jXJ8SG70W-suPAag97NoCAkXAB2AXNGyMJ7AKiTdDRDbwKTFeVOkq2fJFJQ_RPfh7ZbijtQwrw1bvxcM17RyQXZaRKDQ_seSeDeg8pU3upUwBf7IgBP4OLPXRUNbNzmecIrnXkG9CRWeWoDx6AXDP8FzIMYBjWeb5birOBPGaAziltLt85SmCYui45Qwq4aZq9bev1J14TIYy2WWDwg2MaCMFiw5pTw7KpIfyUYMHBJ4T-qgpnqQmYRj-wbWj7Ljjg3HoRkBXJOjJS_lKedilLSIYjgVpPDQxxJEoGXz7-X7gYwAGXZNnG8W9g",
        },
      })
        .then((response) => {
          response.json().then((data) => {
            // console.log("pubname", data);
            for (var i = 0; i < data?.length; i++) {
              pubnames.push({
                id: data[i].publicationID,
                name: data[i].publicationName,
              });
            }
            const multiPay = {
              event: "Publication Name",
              value: pubnames,
            };
            store.dispatch(
              "Rawdata/setPublicationNameSelectedAction",
              pubnames
            );
            store.dispatch("Rawdata/setPublicationNamePayloadAction", pubnames);

            store.dispatch("Rawdata/setSearchCriteriaMultiTextboxes", multiPay);
          });
        })
        .catch(function (e) {
          console.log(e);
        });
    }
    function IntroPricing_multFN(IntroPricing_mult) {
      let cred = IntroductoryPricing.value;
      let temp = [];
      let temp1 = IntroPricing_mult.map(Number);
      for (const m in cred) {
        let flag = temp1.includes(cred[m].id);
        if (flag) {
          temp.push(cred[m]);
          store.dispatch("Media/setAdditionalSelectedDataAction", {
            IntroPricing_mult: cred[m],
          });
          const pay = {
            values: temp1,
            boxname: "Introductory Pricing",
          };
          store.dispatch("Sector/setSiDropDownPayload", pay);
        }
      }
      const searchCry = {
        val: temp1,
        column: "Introductory Pricing",
        entirs: temp,
      };
      store.dispatch("Rawdata/setSearchCritertia", searchCry);
    }

    function postageIdFN(postageId) {
      let storeData = store.getters["Rawdata/getDropdownDataAPI"];
      let postage = storeData.postage_type;
      if (storeData) {
        let temp = [];
        let temp1 = postageId.map(Number);
        for (const m in postage) {
          let flag = temp1.includes(postage[m].postageId);
          if (flag) {
            temp.push(postage[m]);
            store.dispatch("Media/setAdditionalSelectedDataAction", {
              postageId: postage[m],
            });
            const pay = {
              values: temp1,
              boxname: "Postage",
            };
            store.dispatch("Sector/setSiDropDownPayload", pay);
          }
        }
        const searchCry = {
          val: temp1,
          column: "Postage",
          entirs: temp,
        };
        store.dispatch("Rawdata/setSearchCritertia", searchCry);
      }
    }

    function businessContent_multFN(businessContent_mult) {
      let storeData = store.getters["Rawdata/getDropdownDataAPI"];
      if (storeData) {
        let cred = storeData.business_content;
        let temp = [];
        let temp1 = businessContent_mult.map(Number);
        for (const m in cred) {
          let flag = temp1.includes(cred[m].key_id);
          if (flag) {
            temp.push(cred[m]);
            store.dispatch("Media/setAdditionalSelectedDataAction", {
              businessContent_mult: cred[m],
            });
            const pay = {
              values: temp1,
              boxname: "Business Content",
            };
            store.dispatch("Sector/setSiDropDownPayload", pay);
          }
        }
        const searchCry = {
          val: temp1,
          column: "Business Content",
          entirs: temp,
        };
        store.dispatch("Rawdata/setSearchCritertia", searchCry);
      }
    }

    function agentCommunicationIDFN(agentCommunicationID) {
      const communication = store.getters["Sector/getSectorCommData"];

      if (communication) {
        let temp = [];
        let temp1 = agentCommunicationID.map(Number);
        for (const m in communication) {
          let flag = temp1.includes(communication[m].ID);
          if (flag) {
            temp.push(communication[m]);
            store.dispatch("Media/setAdditionalSelectedDataAction", {
              agentCommunicationID: communication[m],
            });
            const pay = {
              values: temp1,
              boxname: "Communication Type",
            };
            store.dispatch("Sector/setSiDropDownPayload", pay);
          }
        }
        const searchCry = {
          val: temp1,
          column: "Communication Type",
          entirs: temp,
        };
        store.dispatch("Rawdata/setSearchCritertia", searchCry);
      }
    }

    function delmethid_multFN(delmethid_mult) {
      let storeData = store.getters["Rawdata/getDropdownDataAPI"];
      let delivery = storeData.delivery_method;
      if (storeData) {
        let delv = delivery;
        let temp = [];
        let temp1 = delmethid_mult.map(Number);
        for (const m in delv) {
          let flag = temp1.includes(delv[m].delmethid);
          if (flag) {
            temp.push(delv[m]);
            store.dispatch("Media/setAdditionalSelectedDataAction", {
              delmethid_mult: delv[m],
            });
            const pay = {
              values: temp1,
              boxname: "Delivery Method",
            };
            store.dispatch("Sector/setSiDropDownPayload", pay);
          }
        }
        const searchCry = {
          val: temp1,
          column: "Delivery Method",
          entirs: temp,
        };
        store.dispatch("Rawdata/setSearchCritertia", searchCry);
      }
    }

    function deliveryTypeIdFN(deliveryTypeId) {
      let storeData = store.getters["Rawdata/getDropdownDataAPI"];
      let delivery = storeData.delivery_type;
      if (storeData) {
        let del = delivery;
        let temp = [];
        let temp1 = deliveryTypeId.map(Number);
        for (const m in del) {
          let flag = temp1.includes(del[m].deliveryTypeId);
          if (flag) {
            temp.push(del[m]);
            store.dispatch("Media/setAdditionalSelectedDataAction", {
              deliveryTypeId: del[m],
            });
            const pay = {
              values: temp1,
              boxname: "Delivery Type",
            };
            store.dispatch("Sector/setSiDropDownPayload", pay);
          }
        }
        const searchCry = {
          val: temp1,
          column: "Delivery Type",
          entirs: temp,
        };
        store.dispatch("Rawdata/setSearchCritertia", searchCry);
      }
    }

    function presortedIdFN(presortedId) {
      let storeData = store.getters["Rawdata/getDropdownDataAPI"];
      let presorted = storeData.presorted_type;
      if (storeData) {
        let pre = presorted;
        let temp = [];
        let temp1 = presortedId.map(Number);
        for (const m in pre) {
          let flag = temp1.includes(pre[m].presortedId);
          if (flag) {
            temp.push(pre[m]);
            store.dispatch("Media/setAdditionalSelectedDataAction", {
              presortedId: pre[m],
            });
            const pay = {
              values: temp1,
              boxname: "Pre-Sorted",
            };
            store.dispatch("Sector/setSiDropDownPayload", pay);
          }
        }
        const searchCry = {
          val: temp1,
          column: "Pre-Sorted",
          entirs: temp,
        };
        store.dispatch("Rawdata/setSearchCritertia", searchCry);
      }
    }

    function groupSizeFN(groupSize) {
      let storeData = store.getters["Rawdata/getDropdownDataAPI"];
      let group = storeData.group_size;
      if (storeData) {
        let grou = group;
        let temp = [];
        let temp1 = groupSize.map(Number);
        for (const m in grou) {
          let flag = temp1.includes(grou[m].id);
          if (flag) {
            temp.push(grou[m]);
            store.dispatch("Media/setAdditionalSelectedDataAction", {
              groupSize: grou[m],
            });
            const pay = {
              values: temp1,
              boxname: "Group Size",
            };
            store.dispatch("Sector/setSiDropDownPayload", pay);
          }
        }
        const searchCry = {
          val: temp1,
          column: "Group Size",
          entirs: temp,
        };
        store.dispatch("Rawdata/setSearchCritertia", searchCry);
      }
    }

    async function ERateType_multFN(ERateType_mult) {
      await dropApiCall(6);
      let energy = store.getters["Sector/getEnergyRateType"];
      console.log(energy, " energy");
      if (energy.length > 0) {
        let ene = energy;
        let temp = [];
        let temp1 = ERateType_mult.map(Number);
        for (const m in ene) {
          let flag = temp1.includes(ene[m].id);
          if (flag) {
            temp.push(ene[m]);
            store.dispatch("Media/setAdditionalSelectedDataAction", {
              ERateType_mult: ene[m],
            });
            const pay = {
              values: temp1,
              boxname: "Energy - Rate Type",
            };
            store.dispatch("Sector/setSiDropDownPayload", pay);
          }
        }
        const searchCry = {
          val: temp1,
          column: "Energy - Rate Type",
          entirs: temp,
        };
        store.dispatch("Rawdata/setSearchCritertia", searchCry);
      }
    }

    function eOfferSymbolRemover(eOffer) {
      let cent = eOffer;
      cent = cent.join(";");
      cent = cent.replaceAll("¢", "").replaceAll(" - ", ",");
      cent = cent.replaceAll(/[a-z]/g, "").replace(/\s\s/g, ",");
      cent = cent
        .split(";")
        .sort(function (a, b) {
          if (parseFloat(a) < parseFloat(b)) {
            return -1;
          }
          if (parseFloat(a) > parseFloat(b)) {
            return 1;
          }
          return 0;
        })
        .join(";");
      // console.log(cent, "cent", typeof cent)
      return cent.split(";");
    }
    function EOfferPrice_multFN(EOfferPrice_mult) {
      const additinalRawData = store.getters["Rawdata/getRawAdditionalGetters"];
      let eOffer = additinalRawData.energyOfferPrice.sort(
        (a, b) => b.OfferPriceID - a.OfferPriceID
      );
      let dummy = [];
      eOffer.map((e) => {
        dummy.push(e.OfferPriceName);
      });
      let dataFormatted = eOfferSymbolRemover(dummy);
      if (dataFormatted) {
        let temp = [];
        // let temp1 = EOfferPrice_mult.map((Number))
        for (const m in dataFormatted) {
          let flag = EOfferPrice_mult.includes(dataFormatted[m]);
          if (flag) {
            temp.push(dataFormatted[m]);
            store.dispatch("Media/setAdditionalSelectedDataAction", {
              EOfferPrice_mult: dataFormatted[m],
            });
            const pay = {
              values: EOfferPrice_mult,
              boxname: "Offer Price (¢ per kWh)",
            };
            store.dispatch("Sector/setSiDropDownPayload", pay);
          }
        }
        const searchCry = {
          val: EOfferPrice_mult,
          column: "Offer Price (¢ per kWh)",
          entirs: temp,
        };
        store.dispatch("Rawdata/setSearchCritertia", searchCry);
      }
    }

    function ETermLength_multFN(ETermLength_mult) {
      let storeData = store.getters["Rawdata/getDropdownDataAPI"];
      if (storeData) {
        let term = storeData.term_length;
        let temp = [];
        let temp1 = ETermLength_mult.map(Number);
        for (const m in term) {
          let flag = temp1.includes(term[m].TermLengthID);
          if (flag) {
            temp.push(term[m]);
            store.dispatch("Media/setAdditionalSelectedDataAction", {
              ETermLength_mult: term[m],
            });
            const pay = {
              values: temp1,
              boxname: "Energy - Term Length",
            };
            store.dispatch("Sector/setSiDropDownPayload", pay);
          }
        }
        const searchCry = {
          val: temp1,
          column: "Energy - Term Length",
          entirs: temp,
        };
        store.dispatch("Rawdata/setSearchCritertia", searchCry);
      }
    }

    function MailingTypeFN(mTypeID) {
      let storeData = store.getters["Rawdata/getDropdownDataAPI"];
      if (storeData) {
        let cred = storeData.mailing_type;
        let temp = [];
        let temp1 = mTypeID.map(Number);
        for (const m in cred) {
          let flag = temp1.includes(cred[m].mTypeID);
          if (flag) {
            temp.push(cred[m]);
            store.dispatch("Media/setAdditionalSelectedDataAction", {
              mTypeID: cred[m],
            });
            const pay = {
              values: temp1,
              boxname: "Mailing Type",
            };
            store.dispatch("Sector/setSiDropDownPayload", pay);
          }
        }
        const searchCry = {
          val: temp1,
          column: "Mailing Type",
          entirs: temp,
        };
        store.dispatch("Rawdata/setSearchCritertia", searchCry);
      }
    }

    //dma
    async function DMA_ID_multFN(DMA_ID_mult) {
      // console.log(DMA_ID_mult, "DMA_ID_mult");
      let temp1 = DMA_ID_mult.map(Number);
      // console.log(temp1, "temp1");
      await dropApiCall(2);
      let dmaRawData = store.getters["Sector/getdropDownDataDma"];
      // console.log(dmaRawData, "dmaRawData");
      if (dmaRawData) {
        let temp = [];
        for (const m in dmaRawData) {
          // console.log(dmaRawData[m]);
          let flag = temp1.includes(Number(dmaRawData[m].code));
          if (flag) {
            temp.push(dmaRawData[m]);
            // console.log(dmaRawData[m], "dmaRawData[m]");
            store.dispatch("Media/setAdditionalSelectedDataAction", {
              DMA_ID_mult: dmaRawData[m],
            });
            // console.log(temp, "dm temp");
            const pay = {
              values: temp1,
              boxname: "DMA®",
            };
            store.dispatch("Sector/setSiDropDownPayload", pay);
          }
        }
        const searchCry = {
          val: temp1,
          column: "DMA®",
          entirs: temp,
        };
        store.dispatch("Rawdata/setSearchCritertia", searchCry);
      }
    }

    //face
    function faceAmountFN(fa_id_mult) {
      const faceAmntData = computed(() => {
        let faceget = store.getters["Sector/getsectorFaceAmtDataGett"];
        return faceget;
      });
      if (faceAmntData.value) {
        let cred = faceAmntData.value;
        let temp = [];
        let temp1 = fa_id_mult.map(Number);
        for (const m in cred) {
          let flag = temp1.includes(cred[m].fa_id);
          if (flag) {
            temp.push(cred[m]);
            store.dispatch("Media/setAdditionalSelectedDataAction", {
              fa_id_mult: cred[m],
            });
            const pay = {
              values: temp1,
              boxname: "Face Amount",
            };
            store.dispatch("Sector/setSiDropDownPayload", pay);
          }
        }
        const searchCry = {
          val: temp1,
          column: "Face Amount",
          entirs: temp,
        };
        store.dispatch("Rawdata/setSearchCritertia", searchCry);
      }
    }

    //value
    async function value_scoreFN(value_score) {
      //  console.log(response, "resp");
      await dropApiCall(5);
      let valueRaw = store.getters["Sector/getdropDownDataScoreHousehold"];
      if (valueRaw) {
        let cred = valueRaw;
        let temp = [];
        for (const m in cred) {
          let flag = value_score.includes(cred[m].code);

          if (flag) {
            temp.push(cred[m]);
            store.dispatch("Media/setAdditionalSelectedDataAction", {
              value_score: cred[m],
            });
            const pay = {
              values: value_score,
              boxname: "Value Score",
            };
            store.dispatch("Sector/setSiDropDownPayload", pay);
          }
        }
        const searchCry = {
          val: temp1,
          column: "Value Score",
          entirs: temp,
        };
        store.dispatch("Rawdata/setSearchCritertia", searchCry);
      }
    }

    //offer
    async function offerOriginFN(offer) {
      //  console.log(response, "resp");
      let obj = store.getters["Rawdata/getofferOriginChanged"];
      let temp1 = offer.map(Number);
      if (obj) {
        let temp = [];
        for (const m in obj) {
          // console.log(dmaRawData[m]);
          let flag = temp1.includes(Number(obj[m].oo_id));
          if (flag) {
            temp.push(obj[m]);
            // console.log(dmaRawData[m], "dmaRawData[m]");
            store.dispatch("Media/setAdditionalSelectedDataAction", {
              offer: obj[m],
            });
            const pay = {
              values: temp1,
              boxname: "Offer Origin",
            };
            store.dispatch("Sector/setSiDropDownPayload", pay);
          }
        }
        const searchCry = {
          val: temp1,
          column: "Offer Origin",
          entirs: temp,
        };
        store.dispatch("Rawdata/setSearchCritertia", searchCry);
      }
    }

    //rider
    function riders_multFN(riders_mult) {
      let storeRider = store.getters["Sector/getsectorIdRiders"];
      console.log(storeRider, "storeRider");
      if (storeRider) {
        let cred = storeRider;
        let temp = [];
        let temp1 = riders_mult.map(Number);
        for (const m in cred) {
          let flag = temp1.includes(cred[m].ridersID);
          if (flag) {
            temp.push(cred[m]);
            store.dispatch("Media/setAdditionalSelectedDataAction", {
              riders_mult: cred[m],
            });
            const pay = {
              values: temp1,
              boxname: "Riders",
            };
            store.dispatch("Sector/setSiDropDownPayload", pay);
          }
        }
        const searchCry = {
          val: temp1,
          column: "Riders",
          entirs: temp,
        };
        console.log(temp, 11, temp1);
        store.dispatch("Rawdata/setSearchCritertia", searchCry);
      }
    }

    //issue
    function IssueTypeID_multFN(IssueTypeID_mult) {
      let faceget = store.getters["Rawdata/getDropdownDataAPI"].issue;
      console.log(faceget, "Face");
      if (faceget) {
        let cred = faceget;
        let temp = [];
        let temp1 = IssueTypeID_mult.map(Number);
        for (const m in cred) {
          let flag = temp1.includes(cred[m].IssueTypeID);
          if (flag) {
            temp.push(cred[m]);
            store.dispatch("Media/setAdditionalSelectedDataAction", {
              IssueTypeID_mult: cred[m],
            });
            const pay = {
              values: temp1,
              boxname: "Issue Type",
            };
            store.dispatch("Sector/setSiDropDownPayload", pay);
          }
        }
        const searchCry = {
          val: temp1,
          column: "Issue Type",
          entirs: temp,
        };
        store.dispatch("Rawdata/setSearchCritertia", searchCry);
      }
    }

    //affinity
    function affinityAssociationFN(affCheck, affCat, affSubcat) {
      const additinalRawData = store.getters["Rawdata/getRawAdditionalGetters"];
      // console.log(affCheck, 1, affCat, 2, affSubcat);
      if (additinalRawData) {
        let affCatRaw = additinalRawData.affinityCategory;
        let affsubCatRaw = additinalRawData.affinitySubCategory;
        let selectedCattemp = [];
        let selectedSubCattemp = [];
        let affCatTemp;
        if (affCat.length > 0) {
          affCatTemp = affCat.map(Number);
        }
        let affSubCatTemp;
        if (affSubcat.length > 0) {
          affSubCatTemp = affSubcat.map(Number);
        }
        store.dispatch("Media/setAdditionalSelectedDataAction", {
          affinityAssociation: affCheck,
        });
        for (const cat in affCatRaw) {
          let flagCat = affCatTemp.includes(affCatRaw[cat].AffinityCategoryID);
          if (flagCat) {
            selectedCattemp.push(affCatRaw[cat]);
            store.dispatch("Media/setAdditionalSelectedDataAction", {
              AffinityCategoryID_mult: affCatRaw[cat],
            });
          }
        }
        for (const sub in affsubCatRaw) {
          let flagSubCat = affSubCatTemp.includes(
            affsubCatRaw[sub].AffinityCategoryID
          );
          if (flagSubCat) {
            selectedSubCattemp.push(affsubCatRaw[sub]);
            store.dispatch("Media/setAdditionalSelectedDataAction", {
              AffinitySubCategoryID_mult: affsubCatRaw[sub],
            });
          }
        }
      }
    }

    function responseMechHandler() {
      // console.log("id", id);
      let responseMech =
        store.getters["Rawdata/getDropdownDataAPI"].response_machanism;
      // const allSectorIds = store.getters["Sector/getsectorIdComm"];
      // console.log(responseMech, "responseMech");

      let arr1 = [4, 5, 530];
      let arr2 = [372, 87, 90, 6, 315, 513, 522, 266, 525, 9, 219];
      let finalresponseMech = [];
      // console.log(allSectorIds, "allSectorIds");
      for (let i = 0; i <= arr1.length; i++) {
        sectorIdsSelected.value.forEach((a) => {
          if (arr1[i] === a) responseMFlagInsurance.value = true;
        });
      }

      for (let j = 0; j <= arr2.length; j++) {
        sectorIdsSelected.value.forEach((b) => {
          if (arr2[j] === b) responseMFlagRest.value = true;
        });
      }
      // console.log(responseMFlagInsurance, "insInvHrFlag");
      // console.log(responseMFlagRest, "restFlag");

      if (responseMFlagInsurance.value && responseMFlagRest.value) {
        store.dispatch("Sector/setresponseMechanismAPIAction", responseMech);
      } else if (responseMFlagInsurance.value) {
        finalresponseMech = responseMech.filter(
          (f) => Number(f.responseMechID) !== 2
        );

        store.dispatch(
          "Sector/setresponseMechanismAPIAction",
          finalresponseMech
        );
      } else if (responseMFlagRest.value) {
        finalresponseMech = responseMech.filter(
          (f) => Number(f.responseMechID) !== 1
        );
        store.dispatch(
          "Sector/setresponseMechanismAPIAction",
          finalresponseMech
        );
      }
    }

    function categoriesLastSearchFunction(ids) {
      let localCat = store.getters["Sector/getcategorySector"];
      let selectedCategories = [];
      for (let c of localCat) {
        if (ids.includes(c.id.toString())) {
          selectedCategories.push(c);
          store.dispatch("Sector/setcategoryPayloadAct", c.id);
          offerOriginFn(c.id, "add");
          let faceOriginal =
            store.getters["Rawdata/getDropdownDataAPI"].faceamount;
          store.dispatch("Sector/setSectorFaceAmtData", faceOriginal);
        }
      }
      selectedCategories.forEach((t) => {
        subsectorsFnHandler(t.id, "Sector/setSubCategoryAction", t.name);
      });
      for (let i = 0; i < ids.length; i++) {
        if (ids[i] === 13) {
          store.dispatch("Sector/setTermLength", true);
          break;
        } else {
          store.dispatch("Sector/setTermLength", false);
        }
      }

      let ridersOriginal = store.getters["Rawdata/getDropdownDataAPI"].riders;
      let ridersDataNames = [];
      if (ids.length > 0) {
        for (let i = 0; i < ridersOriginal.length; i++) {
          let secidArray = ridersOriginal[i].riders_sectorID
            .split(",")
            .map((id) => id.trim());
          let status = !secidArray.includes(ids.toString());
          if (!status) {
            ridersDataNames.push(ridersOriginal[i]);
          }
        }
      }
      store.dispatch("Sector/setSectorIdsRiders", ridersDataNames);

      let issuesOriginal = store.getters["Rawdata/getDropdownDataAPI"].issue;
      let issueDataNames = [];
      if (ids.length > 0) {
        // console.log(11, e[0].sectorID);
        for (let i = 0; i < issuesOriginal.length; i++) {
          let secidArray = issuesOriginal[i].sector_id
            .split(",")
            .map((id) => id.trim());
          let status = secidArray.includes(ids.toString());
          if (status) {
            issueDataNames.push(issuesOriginal[i]);
          }
        }
      }
      store.dispatch("Sector/setIssueTypeData", issueDataNames);

      const searchCry = {
        val: ids,
        column: "Category",
        entirs: selectedCategories,
      };
      store.dispatch("Rawdata/setSearchCritertia", searchCry);
      store.dispatch("Sector/setcategorySelectedAct", selectedCategories);
    }

    async function subsectorsFnHandler(id, actionName, name) {
      let subcat = store.getters["Sector/getAllSubCategoryLocalGetters"];
      let showsubcatstore = store.getters["Sector/getSubCategoryGetters"];
      // let storeData = store.getters["Sector/getcategorySector"];
      // Create a Set to store unique values
      let uniqueValues = new Set();
      // console.log(catnameIsSelected, "catnameIsSelected");
      // Filter unique values from 'cat' array based on the condition
      // eslint-disable-next-line no-unused-vars
      Object.entries(subcat).forEach(([key, value]) => {
        if (value.subpid === id) {
          uniqueValues.add(value);
        }
      });

      // Filter unique values from 'showcatstore' array
      // Convert the Set back to an array ('showcat') to match your original data structure
      let showcat = [...uniqueValues];
      showcat.forEach((p) => {
        let arrowFlag = p.name.includes(" >> ");
        if (!arrowFlag) {
          p.name = name + " >> " + p.name;
        }
      });

      //MATCH showsubcatstore and showcat merge it if its unique
      let newsubcatid = [];
      for (let i = 0; i < showcat.length; i++) {
        newsubcatid.push(showcat[i].id);
      }
      for (let j = 0; j < showsubcatstore.length; j++) {
        if (!newsubcatid.includes(showsubcatstore[j].id)) {
          showcat.push(showsubcatstore[j]);
        }
      }
      store.dispatch(actionName, showcat);
    }
    function subcategories(ids) {
      let localSubCat = store.getters["Sector/getAllSubCategoryLocalGetters"];
      let selectedSubCategories = [];
      for (let c of localSubCat) {
        if (ids.includes(c.id.toString())) {
          selectedSubCategories.push(c);
          store.dispatch("Sector/setsubcategoryPayloadAct", c.id);
        }
      }
      selectedSubCategories.forEach((t) => {
        subsubsectorsFnHandler(t.id, "Sector/setSubSubCategoryAction", t.name);
      });
      store.dispatch("Sector/setsubcategorySelectedAct", selectedSubCategories);
      const searchCry = {
        val: ids,
        column: "Sub Category",
        entirs: selectedSubCategories,
      };
      store.dispatch("Rawdata/setSearchCritertia", searchCry);
    }

    function subsubsectorsFnHandler(id, actionName, name) {
      let subsubcat = store.getters["Sector/getAllSubSubCategoryLocalGetters"];
      let showsubsubcatstore = store.getters["Sector/getSubSubCategoryGetters"];
      let faceOriginal = store.getters["Rawdata/getDropdownDataAPI"].faceamount;
      let faceamount = store.getters["Sector/getsectorFaceAmtDataGett"];
      let uniqueValues = new Set();

      // Filter unique values from 'cat' array based on the condition
      // eslint-disable-next-line no-unused-vars
      Object.entries(subsubcat).forEach(([key, value]) => {
        if (value.subsubpid === id) {
          uniqueValues.add(value);
        }
      });
      if (faceamount.length == 0) {
        store.dispatch("Sector/setSectorFaceAmtData", faceOriginal);
      }

      // Filter unique values from 'showcatstore' array
      showsubsubcatstore.forEach((t) => {
        uniqueValues.add(t);
      });
      // Convert the Set back to an array ('showcat') to match your original data structure
      let showsubcat = [...uniqueValues];
      showsubcat.forEach((p) => {
        let arrowFlag = p.name.includes(" >> ");
        console.log(arrowFlag, "arrowFlag");
        if (!arrowFlag) {
          let ind = name.indexOf(" >> ");
          console.log(ind, "ind");
          if (ind !== -1) {
            let temp = name.slice(ind + 3, name.length) + " >> " + p.name; //this is adding subparent name with children names
            console.log(temp, "temp");
            p.name = temp;
          } else {
            let temp = name + " >> " + p.name; //this is adding subparent name with children names
            p.name = temp;
          }
        }
      });
      store.dispatch(actionName, showsubcat);
    }

    function subsubcategories(ids) {
      let subsubcat = store.getters["Sector/getAllSubSubCategoryLocalGetters"];
      let selectedSubsubCategories = [];
      for (let c of subsubcat) {
        if (ids.includes(c.id.toString())) {
          selectedSubsubCategories.push(c);
          store.dispatch("Sector/setsubsubcategoryPayloadAct", c.id);
        }
      }

      let catPayload = store.getters["Sector/getcategoryPayload"];
      Object.keys(catPayload).find((key) => {
        if (key === "cat_ssub") {
          ids.forEach((i) => {
            if (!catPayload[key].includes(i)) {
              store.dispatch("Sector/setsubsubcategoryPayloadAct", i);
            }
          });
        }
      });

      const searchCry = {
        val: ids,
        column: "Sub Sub Category",
        entirs: selectedSubsubCategories,
      };
      store.dispatch("Rawdata/setSearchCritertia", searchCry);

      store.dispatch(
        "Sector/setsubsubcategorySelectedAct",
        selectedSubsubCategories
      );

      let ridersOriginal = store.getters["Rawdata/getDropdownDataAPI"].riders;
      let ridersDataNames = [];
      // console.log("3data", ridersOriginal, e);
      if (ids.length > 0) {
        // console.log(11, e[0].id);
        for (let i = 0; i < ridersOriginal.length; i++) {
          let secidArray = ridersOriginal[i].riders_sectorID
            .split(",")
            .map((id) => id.trim());
          let status = !secidArray.includes(ids.toString());
          if (!status) {
            ridersDataNames.push(ridersOriginal[i]);
          }
        }
      }
      // console.log("ridersDataNames", ridersDataNames);
      store.dispatch("Sector/setSectorIdsRiders", ridersDataNames);

      let issuesOriginal = store.getters["Rawdata/getDropdownDataAPI"].issue;
      let issueDataNames = [];
      if (ids.length > 0) {
        // console.log(11, e[0].sectorID);
        for (let i = 0; i < issuesOriginal.length; i++) {
          let secidArray = issuesOriginal[i].sector_id
            .split(",")
            .map((id) => id.trim());
          let status = secidArray.includes(ids.toString());
          if (status) {
            issueDataNames.push(issuesOriginal[i]);
          }
        }
      }
      // console.log(issueDataNames, "issueDataNames");
      store.dispatch("Sector/setIssueTypeData", issueDataNames);
    }

    function subsubcategoriesPayload(e) {}
    function showpdfPreview(pid) {
      offSetTop.value = 155;
      // let y = 0;
      for (const p in eachRow.value) {
        if (eachRow.value[p].id == pid) {
          offSetTop.value += eachRow.value[p].offsetTop;
        }
      }

      let elementsArray = document.getElementsByClassName("popup-pdf");

      Object.entries(elementsArray).forEach((p) => {
        if (p[1].id == pid) {
          p[1].style.display = "block";
          p[1].style.top = offSetTop.value.toString() + "px";
        } else {
          p[1].style.display = "none";
        }
      });

      for (const p in pdfHoverData.value) {
        if (pdfHoverData.value[p].productID === pid) {
          dynamicPDFPreview.value = pdfHoverData.value[p].downlaod_url;
          pdfHoverPop.value = true;
          setTimeout(() => {}, 500);
        }
      }
    }
    function setStickyHeader() {
      const table = tableRef.value;
      // console.log(table, "table");

      if (table) {
        table.$el.style.display = "block";
        table.$el.style.overflow = "auto";
      }
    }

    const myExcelActivation = () => {
      // myexcelActivateStatusLocal.value = !myexcelActivateStatusLocal.value;
      // store.dispatch(
      //   "Rawdata/setmyexcelActivationAction",
      //   myexcelActivateStatusLocal.value
      // );
      // window.open(window.location.origin + "/" + `myexcel`);
      router.push({ path: "/myexcel" }); // -> /user/eduardo
    };
    function fileSizes(f) {
      // console.log(f, "f");
      loader.value = false;
      const apiUrl = `${http.value.filesize}`;
      // const apiUrl = "https://dev02.competiscan.com:5012/filesize";

      // Fetch data from the API
      // console.log("filesize.", f);
      fetch(apiUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ product_ids: f }),
      })
        .then((response) => {
          response.json().then((data) => {
            // console.log("filesize", data);
            for (let i = 0; i < newdata.value.length; i++) {
              for (let j = 0; j < data.length; j++) {
                if (newdata.value[i].ProductId === data[j].productID) {
                  newdata.value[i]["url"] = data[j].url;
                  if (data[j].document_size_byte <= 999999) {
                    newdata.value[i]["size"] =
                      (data[j].document_size_byte / 1024).toFixed(2) + "KB";
                    newdata.value[i]["document_content_type"] =
                      data[j].document_content_type;
                    newdata.value[i]["document_size_byte"] =
                      data[j].document_size_byte;
                    newdata.value[i]["document_path"] = data[j].document_path;
                  } else {
                    newdata.value[i]["size"] =
                      (data[j].document_size_byte / (1024 * 1024)).toFixed(2) +
                      "MB";
                    newdata.value[i]["document_content_type"] =
                      data[j].document_content_type;
                    newdata.value[i]["document_size_byte"] =
                      data[j].document_size_byte;
                    newdata.value[i]["document_path"] = data[j].document_path;
                  }
                  loader.value = false;
                }
              }
            }
          });
          // console.log("newdata", newdata);
        })
        .catch(function (e) {
          console.log(e);
        });
    }
    function headlineHover(id) {
      isHovering.value = !isHovering.value;
      highlightedIndex.value = id;
    }
    function sortCategories(cat, ev) {
      // console.log("filter.", cat.length);
      if (cat !== undefined && cat.length > 0) {
        cat.sort(function (a, b) {
          if (a.toLowerCase() < b.toLowerCase()) {
            return -1;
          }
          if (a.toLowerCase() > b.toLowerCase()) {
            return 1;
          }
          return 0;
        });
        if (ev === "cat") {
          categories.value = cat;
        } else if (ev === "sub_cat") {
          subCategories.value = cat;
        } else if (ev === "sub_sub_cat") {
          subSubCategories.value = cat;
        }
      }
    }
    function filterPrimaryAndAdditionalCompanies(
      primary_company_name,
      company
    ) {
      companiesImpData.value = {
        primaryCompanyId: 0,
        primaryCompanyName: "",
        additionalCompanyName: [],
      };
      // console.log("filter", primary_company_name, company);
      for (let i = 0; i < company.length; i++) {
        // console.log("filter", company[i]);
        if (company[i].company_name === primary_company_name) {
          // console.log("filter.", company[i].company_id);
          // console.log("filter.primary", company[i].company_name);
          companiesImpData.value.primaryCompanyId = company[i].company_id;
          companiesImpData.value.primaryCompanyName = company[i].company_name;
        } else {
          // console.log("filter..sec", company[i].company_name);
          // companiesImpData.value.additionalCompanyName = [];

          companiesImpData.value.additionalCompanyName.push(
            company[i].company_name
          );
        }
        companiesImpData.value.additionalCompanyName.sort(function (a, b) {
          if (a < b) {
            return -1;
          }
          if (a > b) {
            return 1;
          }
          return 0;
        });
        // console.log("filt111er.", companiesImpData.value);
      }
    }

    // function updatePagination() {
    //   // const paginationElement = document.getElementById("pagination");
    //   // paginationElement.innerHTML = "";

    //   const startPage = Math.max(
    //     page.value - Math.floor(pagesToShow.value / 2),
    //     1
    //   );
    //   const endPage = Math.min(
    //     startPage + pagesToShow.value - 1,
    //     totalPages.value
    //   );

    //   console.log("startPage", startPage);
    //   console.log("endPage", endPage);
    //   console.log("pagesToShow", pagesToShow.value);
    //   console.log("page", page.value);
    //   console.log("totalPages", totalPages.value);
    //   for (let i = startPage; i <= endPage; i++) {
    //     const li = document.createElement("li");
    //     li.textContent = i;
    //     if (i === page.value) {
    //       li.classList.add("active");
    //     }
    //     li.addEventListener("click", () => {
    //       page.value = i;
    //       updatePagination();
    //     });
    //     paginationElement.appendChild(li);
    //   }
    // }

    // function updatePagination() {
    //   const startPage = Math.max(
    //     page.value - Math.floor(pagesToShow.value / 2),
    //     1
    //   );
    //   const endPage = Math.min(
    //     startPage + pagesToShow.value - 1,
    //     totalPages.value
    //   );
    //   console.log(
    //     Array.from(
    //       { length: endPage - startPage + 1 },
    //       (_, index) => startPage + index
    //     )
    //   );
    //   return Array.from(
    //     { length: endPage - startPage + 1 },
    //     (_, index) => startPage + index
    //   );
    // }

    const displayedPages = computed(() => {
      const startPage = Math.max(
        page.value - Math.floor(pagesToShow.value / 2),
        1
      ); // this will get start page number by having minimum start page which is 1 and compare from page clicked number - pagestoshow(10)/2

      const endPage = Math.min(
        startPage + pagesToShow.value - 1,
        maxPgNum.value
      ); // this will have the minimum value which should be max page number coming from api
      // console.log("endPage", endPage);
      // console.log("pagesToShow", pagesToShow.value);
      // console.log("disp page", page.value, "max", maxPgNum.value);
      // console.log("start", startPage, "endPage", endPage);
      // console.log("totalPages", totalPages.value);
      // console.log(pageData.value, "page");
      return Array.from(
        {
          length:
            endPage - startPage + 1 === totalPages.value
              ? endPage - startPage + 1
              : totalPages.value,
        },
        (_, index) => startPage + index
      );
      // this is returning starting number of where pagination will start in the dom and
      // where the number will be highlighted in the pagination.
    });

    function searchResultFormatting(data) {
      // console.log("f", data);
      pageCount.value = data.pages?.length;
      let len = Object.keys(data).length;
      timeTaken.value = data.time_taken?.toFixed(2);
      totalRecords.value = data.total_records;

      if (len > 0) {
        let apidataresult = data.results;
        newdata.value = [];
        apidataresult?.forEach((t) => {
          newdata.value.push({
            ["sort_by"]: {
              ["ProductId"]: t.product_id,
            },
            ["headline"]: {
              ["headline"]: t.product_headline,
              ["MediaChannel"]: t.mchannel_name,
              ["Audience"]: t.audience_name,
            },
            ["company"]: {
              ["companyName"]: t.primary_company_name,
              ["sectorName"]: collateSectorNames(t.sector_id),
            },
            ["entryid"]: {
              ["EntryID"]: t.entry_id,
              ["Category"]: t.sector_categories.category?.join(","),
              ["SubCategory"]: t.sector_categories.sub_category?.join(","),
              ["SubSubCategory"]:
                t.sector_categories.sub_sub_category?.join(","),
            },
          });
        });
        window.scrollTo(0, 0);
        // console.log("new", newdata.value);
        // callapi(page.value);
      }
    }

    function pageEventHandler(pnumb, st) {
      // console.log(pnumb, "pnumb", st, pageCount.value);
      //console.log(displayedPages, "displayedPages");
      let pastNumb = store.getters["Rawdata/getlastPageNoGetters"];
      store.dispatch("Rawdata/lastPageNoAction", pnumb);
      //console.log(pnumb, st);
      isLoading.value = true;
      page.value = pnumb;
      let allPages = store.getters["Rawdata/getsearchResultGetters"].pages;
      let bodydatagetter = store.getters["Rawdata/getsearchAPIBodyGetters"];
      // let oldpagevalue = store.getters["Rawdata/getOldPageValueGetters"];
      //console.log(bodydatagetter, " body");
      let payload = store.getters["Rawdata/getActionPayload"];
      //console.log(payload, "pagi payload");
      for (let key in allPages) {
        if (allPages[key].pg_no == page.value) {
          // console.log(allPages[key].sid[0], allPages[key].sid[1]);
          let temp = allPages[key].sid;
          // let bb = [];
          // let temp2 = [];
          // temp.forEach((t) => temp2.push(Number(t)));
          sid.value = temp;
        }
      }
      //console.log(sid.value);
      if (st === "p") {
        store.dispatch("Rawdata/previousPaginationFlagAction", true);
        store.dispatch("Rawdata/lastPaginationFlagAction", false);
      }
      if (st === "next") {
        store.dispatch("Rawdata/nextPaginationFlagAction", true);
        store.dispatch("Rawdata/lastPaginationFlagAction", false);
      }
      if (st === "last") {
        store.dispatch("Rawdata/lastPaginationFlagAction", true);
      }
      // if (st === "f") {
      //   page.value = 1;
      // }
      // console.log(sid.value, "sid");
      Object.keys(bodydatagetter).find((key) => {
        if (key === "mchanne_id") {
          media.value = bodydatagetter[key];
        }
        if (key === "sector_id") {
          sector.value = bodydatagetter[key];
        }
        if (key === "mpanel_id") {
          audience.value = bodydatagetter[key];
        }
      });

      Object.keys(payload).find((key) => {
        if (key === "mchanne_id") {
          media.value = payload[key];
        }
        if (key === "sector_id") {
          sector.value = payload[key];
        }
        if (key === "mpanel_id") {
          audience.value = payload[key];
        }
        if (key === "page_type") {
          payload[key] = 2;
        }
      });
      let dir = "";
      if (lastPageStatus.value) {
        dir = "bck";
      } else {
        dir = "fwd";
      }
      // console.log(sid.value.length, "sid len");
      let tempsid =
        sid.value.length > 0 ? JSON.stringify(Object.values(sid.value)) : "";
      // console.log(JSON.stringify(Object.values(sid.value)));
      let newbody = {};
      // console.log(tempsid.length, "temp");
      //console.log(tempsid, "temp");

      if (tempsid.length > 0) {
        let prevStatus =
          store.getters["Rawdata/getpreviousPaginationFlagGetters"];
        let nextStatus = store.getters["Rawdata/getnextPaginationFlagGetters"];
        let lastStatus = store.getters["Rawdata/getlastPaginationFlagGetters"];
        newbody = {
          ...payload,
          direction: dir,
          // pg_no: page.value.toString(),
          page_type: st === "last" ? "3" : "2",
          current_page: pnumb.toString(),
          sid: JSON.stringify(Object.values(sid.value)),
        };
        if (st === "n" && !prevStatus && !nextStatus && lastStatus) {
          newbody.direction = "bck";
        } else {
          newbody.direction = "fwd";
        }
        if (pastNumb && nextStatus) {
          if (pnumb > pastNumb) {
            newbody.direction = "bck";
          }
        }

        if (lastStatus) {
          prevStatus = false;
          newbody.direction = "bck";
        }
        if (prevStatus) {
          lastStatus = false;
          newbody.direction = "bck";
        }
        // if (st === "n" && nextStatus) {
        //   newbody.direction = "fwd";
        // }
        // if (st === "n" && lastStatus) {
        //   newbody.direction = "bck";
        // } else {
        //   newbody.direction = "fwd";
        // }
        if (st === "f") {
          delete newbody.direction;
          delete newbody.current_page;
          newbody.page_type = "1";
          delete newbody.sid;
        }
        if (st === "last") {
          delete newbody.direction;
          delete newbody.current_page;
          newbody.page_type = "3";
          delete newbody.sid;
        }
        if (st === "next") {
          newbody.direction = "fwd";
        }
      } else {
        newbody = {
          ...payload,
          direction: dir,
          // pg_no: page.value.toString(),
          page_type: st === "last" ? "3" : "2",
          current_page: pnumb.toString(),
        };
        // console.log(lastPageStatus.value, "last");
        if (st === "f") {
          delete newbody.direction;
          delete newbody.current_page;
          newbody.page_type = "1";
        }
        if (st === "last") {
          delete newbody.direction;
          delete newbody.current_page;
          newbody.page_type = "3";
          delete newbody.sid;
        }
        console.log(newbody, "pag newbody");
      }

      // console.log(newbody, "111");
      paginationPayload.value = newbody;
      store.dispatch("Rawdata/setActionPayload", newbody);
      // let bodydata = {
      //   mpanel_id: audience.value.toString(),
      //   mchanne_id: media.value.toString(),
      //   sector_id: sector.value.toString(),
      //   page_type: st !== "last" ? "3" : "2",
      //   direction: "fwd",
      //   // pg_no: page.value.toString(),
      //   current_page: pnumb.toString(),
      //   sid: JSON.stringify(Object.values(sid.value)),
      // };

      // bodydata = { ...bodyData.value, ...bodydata };
      store.dispatch("Rawdata/setOldPageValueAction", page.value);
      // console.log(JSON.stringify(bodydata));
      // console.log(12, newbody);
      fetch(`${http.value.vatBackend}/elasticsearch-service/v1/search/`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(newbody),
      }).then((response) => {
        response.json().then(async (data) => {
          console.log("pagin", data);
          let pagesall = Array.from(data.pages);
          console.log(pagesall, " tt", maxPgNum.value);
          //  maxPgNum.value = pagesall.length;
          pagesall.forEach((item) => {
            if (item.pg_no > maxPgNum.value) {
              maxPgNum.value = item.pg_no;
            }
          });
          if (data.current_page === data.total_pages) {
            lastPageStatus.value = true;
          }
          // console.log(Object.keys(data.pages).length, " len");
          totalPages.value = data.pages;
          isLoading.value = false;
          store.dispatch("Rawdata/setsearchResultAction", data);
          store.dispatch("Rawdata/setOldPageValueAction", page.value);
          searchResultFormatting(data);
        });
      });
    }

    function findDataValue(productId, data) {
      for (let item of data) {
        const key = Object.keys(item)[0];
        if (parseInt(key) === productId) {
          return item[key];
        }
      }
      return null; // Return null if no match found
    }
    function getMuidHandler() {
      // pid = pid.toString();
      // console.log(allproductId.value, "prod");
      const apiurl = `${http.value.productmuid}`;
      let tempid = [];
      let mediaLogicExistence = false;
      let audienceLogicExistence = false;
      searchResultData.value.results?.forEach((t) => {
        tempid.push(t.product_id);
        // console.log(t.audience_name);
        if (t.mchannel_name === "Email") {
          mediaLogicExistence = true;
          // audienceLogicExistence = [1, 2].some(audience[a]);
        }
        if (
          t.audience_name === "Consumer" ||
          t.audience_name === "Employer/Business Owner"
        ) {
          audienceLogicExistence = true;
          // audienceLogicExistence = [1, 2].some(audience[a]);
        }
      });
      // console.log("tempid", tempid);
      fetch(apiurl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ product_ids: tempid }),
      })
        .then((response) => {
          response.json().then((data) => {
            // console.log(data, "data");
            if (data) {
              if (data.length > 0) {
                // console.log(data, "1data");
                const matchedValues = [];

                // allMuids.value = data;
                // console.log(allMuids.value, "allMuids.value");
                // eslint-disable-next-line no-unused-vars
                newdata.value.forEach((item, i) => {
                  const productId = item.ProductId;
                  // console.log(productId, "prod");
                  const matchedValue = findDataValue(productId, data);
                  // console.log(matchedValue, "math");
                  if (matchedValue !== null) {
                    // console.log(item, "item first");
                    // console.log(item[i], "i");
                    // console.log(Object.keys(item), "key");
                    // console.log(mediaLogicExistence, "mediaLogicExistence", audienceLogicExistence);
                    if (
                      Object.keys(item[i] === "isWrench") &&
                      mediaLogicExistence &&
                      audienceLogicExistence
                    ) {
                      newdata.value[i] = {
                        ...newdata.value[i],
                        muid: matchedValue,
                      };
                    } else if (Object.keys(item[i] === "isWrench")) {
                      // console.log(item, "third");
                      newdata.value[i].isWrench = 4;
                    }
                  }
                  matchedValues.push(matchedValue);
                });
                // console.log("new first", newdata.value);
              } else {
                // console.log("fourth");
                newdata.value.forEach((item, i) => {
                  if (Object.keys(item[i] === "isWrench")) {
                    newdata.value[i].isWrench = 4;
                  }
                });
              }
            }
          });
          // console.log("new else", newdata.value);
        })
        .catch(function (e) {
          console.log(e);
        });
    }

    function checkWrenchIcon() {
      // console.log(pid, "pid");
      // console.log("wrench");
      // console.log(allMuids.value, "allMuids.value");
      // let muid = null;
      // eslint-disable-next-line no-unused-vars
      // for (const [key, value] of Object.entries(allMuids.value)) {
      //console.log(value, 23);
      //if (pid == Object.keys(value)) {
      //console.log(Object.values(value));
      //muid = Object.values(value);
      //}
      //}
      //}
      // if (muid) {
      //   console.log(true, "status of muid");
      // } else {
      //   console.log(false, "status of muid");
      // }
      // return muid ? true : false;
    }

    function openHtmlTag(url, id) {
      window.open(url + id, "popup", "width=800,height=800");
    }
    function openHeadlineFnHandler1(e) {
      productDetailPayload.value = e;
      console.log(window, "wind");
      // showProduct.value = true;
      // console.log("SSSS...", e);
      console.log(window.location.href, 22);
      let win = null;
      win = window.open(
        window.location.origin +
          "/" +
          `productdetail?id=${e.ProductId}&checkstatus=1&env=v2`,
        "blank",
        "width=800,height=600,left=200,top=200"
      );
      win.product_deatail_defaults = e;

      // newTab.document.write(product);
      // store.dispatch("Rawdata/setProductDetailBasicInfo", e);
      // console.log("AXSW..", store.getters["Rawdata/getProductDetailBasicInfo"]);
    }
    function openHeadlineFnHandler(item) {
      // console.log(item.headline, "item");
      // console.log(item.raw.headline.headline, "item");
      let content = `
      <div id="div1">
                <div style="padding-bottom:6px;">
<img src="https://www.competiscan.com/images/competiscan-logo.png" border="0" alt="aa"
style="max-height: 50px;" ></img>
</div>
 <table border="0" cellspacing="0" cellpadding="4" >
                        <tbody><tr>
                            <td class="bodytext"><a onclick="printAll(10990391, 'productDocuments.php?id=10990391&amp;did=1', 1); return false;" class="HyperLink" href="#" title="Print Details">Print Details</a></td>
                            <td class="bodytext">                                    <a onclick="printAll(10990391, 'productDocuments.php?id=10990391&amp;did=1', 2); return false;" href="#" class="HyperLink" title="Print PDF">Print PDF</a>
                                                                </td>
                                                        <td class="bodytext"><a onclick="printAll(10990391, 'productDetail.php?id=10990391&amp;did=1&amp;makepdf=1', 2);
                                            return false;" class="HyperLink" href="#" title="Print All">Print All</a></td>

                        </tr>
                    </tbody></table>
                                <div style="margin:0px;padding:0px;border:solid 1px #0055E3;width:99%;">
                    <table width="100%" cellpadding="4" cellspacing="0" class="likeresults" border="0">
                        <tbody><tr>
                            <td valign="top" class="text" colspan="2" style="background:#0055E3;color:#FFFFFF;font-size:0.8em;">${item.headline}
</td>
                        </tr>
                        <tr>
                                                            <td valign="top"><img src="https://www.competiscan.com/productImg.php?cid=19006" style="border: solid 1px #000000;" alt=""></td>
                                <td class="bodytext" valign="bottom">
                                                                                    <a class="bluelink" href="productDocuments.php?id=10990391&amp;did=1" onclick="printAll(10990391, 'productDocuments.php?id=10990391&amp;did=1', 3); return false;">View PDF Content <img src="images/pdf.jpg" border="0" style="vertical-align:top;"></a>
                                       &nbsp;  [253.62 KB]                                        <br>
                                                                      </td>

                                              </tr>
                        <tr>
                            <td class="bodytext" valign="top" width="50%"><strong>Entry ID:</strong> <a href="https://cs.competiscan.com/addproduct/v2/10990391?ec_content_type=direct" target="_blank" class="bluelink">2023-09-15-3697</a>                            </td>
                            <td class="bodytext" valign="top"><strong>Estimated Mail Volume:</strong> <a href="#" onclick="showCalc(2); return false;" class="bluelink" id="thecalclink">36,408</a><div style="display:none;position:absolute;background:#ffffff;padding:0px;border:solid 2px #000000;z-index:100;width:635px;" id="thecalc"><div style="float:right;height:26px;"><a href="#" onclick="hideCalc(); return false;" class="bluelink">close</a> &nbsp; </div><div style="clear:both;height:1px"><img src="images/spacer.gif" width="1" height="1"></div><div id="thecalc_inner" style="padding:4px;"><table id="thecalc_table" border="0" cellspacing="2" cellpadding="4" class="bodytext_small" style="width:100%;">
				<tbody><tr><td class="bodytext" width="40%"><strong>Historical EMV</strong></td><td style="border:none;">&nbsp;</td><td class="bodytext"><strong>Mail Piece Observance</strong></td></tr><tr><td style="border:none;"><table border="0" cellspacing="1" cellpadding="3" class="bodytext_small" width="100%"><tbody><tr><td><strong>Estimated Mail Volume</strong></td><td>36,408</td></tr><tr><td><strong>2023 EMV</strong></td><td>36,408</td></tr></tbody></table></td><td style="border:none;">&nbsp;</td><td style="border:none;"><table border="0" cellspacing="1" cellpadding="3" class="bodytext_small"><tbody><tr>
				<td>&nbsp;</td><td><strong>JAN</strong></td><td><strong>FEB</strong></td><td><strong>MAR</strong></td><td><strong>APR</strong></td><td><strong>MAY</strong></td><td><strong>JUN</strong></td><td><strong>JUL</strong></td><td><strong>AUG</strong></td><td><strong>SEP</strong></td><td><strong>OCT</strong></td><td><strong>NOV</strong></td><td><strong>DEC</strong></td></tr><tr><td><strong>2023</strong></td><td align="center">&nbsp;</td><td align="center">&nbsp;</td><td align="center">&nbsp;</td><td align="center">&nbsp;</td><td align="center">&nbsp;</td><td align="center">&nbsp;</td><td align="center">&nbsp;</td><td align="center">&nbsp;</td><td align="center" style="background-color:#0055E3;color:#FFFFFF;font-weight:bold;">X</td><td align="center">&nbsp;</td><td align="center">&nbsp;</td><td align="center">&nbsp;</td></tr></tbody></table></td></tr>
				<tr><td colspan="3" style="border:none;">&nbsp;</td></tr>
				<tr><td colspan="3" class="bodytext"><strong>Estimated Mail Volume Transparency</strong></td></tr>
				<tr><td colspan="3" style="border:none;"><table border="0" cellspacing="1" cellpadding="3" class="bodytext_small" width="100%">
				<tbody><tr><td valign="bottom" style="border:none;" align="center"><strong>Panelist</strong></td>
                                <td valign="bottom" align="center"><strong>Age</strong></td>
                                <td valign="bottom" align="center"><strong>Income</strong></td>
                                <td valign="bottom" align="center"><strong>State / Province</strong></td><td valign="bottom" align="center"><strong>FicoScore</strong></td><td valign="bottom" align="center"><strong>CreditVision</strong></td><td valign="bottom" align="center"><strong>VantageScore</strong></td><td valign="bottom" align="center"><strong>ValueScore®</strong></td><td valign="bottom" align="center"><strong>ISO Risk Quality Index-Auto</strong></td>
                                <td valign="bottom" align="center"><strong>ISO Risk Quality Index-Home</strong></td>
                                <td valign="bottom" align="center"><strong>EMV</strong></td></tr><tr><td style="border:none;" nowrap="nowrap"><a href="#" onclick="showCalcCos_digital(61410); return false;" class="bluelink" style="font-size: 10px; color:black;" id="thecalccoslink61410"><strong> 41326-12-37 </strong></a></td><td align="center" valign="top">31</td><td align="center" valign="top">Under $25k</td><td align="center" valign="top">New York</td><td align="center" valign="top"></td><td align="center" valign="top"></td><td align="center" valign="top"></td><td align="center" valign="top"><a href="#" class="bluelink" onclick="showValueScore(61410); return false;" style="font-size: 10px;" id="ValueScorelink61410">A1</a></td><td align="center" valign="top">&nbsp;</td>
						<td align="center" valign="top">&nbsp;</td>
						<td align="center" valign="top">36,408</td></tr></tbody></table></td></tr></tbody></table></div></div><div style="display:none;position:absolute;background:#E8E8FF;padding:0px;border:solid 1px #000000;z-index:102;width:420px;" id="ValueScore"><div style="float:right;height:26px;"><a href="#" onclick="hideValueScore(); return false;" class="bluelink">close</a> &nbsp; </div><div style="clear:both;height:1px"><img src="images/spacer.gif" width="1" height="1"></div><div id="ValueScore_inner61410" style="display:none;padding:4px;">A1 = Best Profit Potential (760)</div></div><div style="display:none;position:absolute;background:#E8E8FF;padding:0px;border:solid 1px #000000;z-index:103;width:500px;" id="ISO"><div style="float:right;height:26px;"><a href="#" onclick="hideISO(); return false;" class="bluelink">close</a> &nbsp; </div><div style="clear:both;height:1px"><img src="images/spacer.gif" width="1" height="1"></div><div id="ISO_inner" style="padding:4px;">ISO© defines risk as the expected amount of loss for either a Personal Auto or Homeowners claim.  Within a geography (State/Province, County, or ZIP), the likelihood of Personal Auto or Homeowner claims is not uniform.  Some areas will have higher/lower tendencies of insurance related losses.  ISO©  ERI (environmental relativity index) helps insurers identify the low and high relative areas or loss potential.</div></div><div style="display:none;position:absolute;background:#E8E8FF;padding:0px;border:solid 1px #000000;z-index:101;width:420px;" id="thecalccos"><div style="float:right;height:26px;"><a href="#" onclick="hideCalcCos(); return false;" class="bluelink">close</a> &nbsp; </div><div style="clear:both;height:1px"><img src="images/spacer.gif" width="1" height="1"></div><div id="thecalccos_inner" style="padding:4px;"></div></div>
                            </td>


                        </tr>
                                                    <tr><td class="bodytext" valign="top"><strong>Media Channel:</strong> ${item.MediaChannel}
</td><td class="bodytext" valign="top"><strong>Audience:</strong> ${item.Audience}
</td></tr><tr><td class="bodytext" valign="top"><strong>Primary Company:</strong> ${item.companyName}
</td><td class="bodytext" valign="top"><strong>Additional Companies:</strong> Chrysler</td></tr><tr><td class="bodytext" valign="top"><strong>State/Province:</strong> New York</td><td class="bodytext" valign="top"><strong>Sector:</strong> ${item.sectorName}
</td></tr><tr><td class="bodytext" valign="top"><strong>Category:</strong> ${item.Category}
 Services</td><td class="bodytext" valign="top"><strong>Sub Category:</strong> ${item.SubCategory}
</td></tr><tr><td class="bodytext" valign="top"><strong>Affinity/Association:</strong> No</td><td class="bodytext" valign="top"><strong>Campaign Language:</strong> English</td></tr><tr><td class="bodytext" valign="top"><strong>Age:</strong> 30-39</td><td class="bodytext" valign="top"><strong>Income:</strong> Under $25k</td></tr><tr><td class="bodytext" valign="top"><strong>Mailing Type:</strong> Follow-Up</td><td class="bodytext" valign="top"><strong>Estimated Spend:</strong> $12,132</td></tr><tr><td class="bodytext" valign="top"><strong>Delivery Method:</strong> Mailed</td><td class="bodytext" valign="top"><em><strong>Communication Type:</strong> </em></td></tr>                                                            <tr>
                                <td align="left" valign="top" class="bodytext"><a href="sendLink.php?id=10990391&amp;send_mode=1" class="bluelink" title="Click this if you want to send the products details of this product as a link to your colleague" onclick="sendColleague(10990391, 1);
                                                return false;">Send this as a link to your colleague</a></td>
                                <td align="left" valign="top" class="bodytext">&nbsp;</td>
                            </tr>
                                                                                                                  <tr>
                                    <td align="left" valign="top" class="bodytext"><a href="sendLink.php?id=10990391&amp;send_mode=2" class="bluelink" style="font-style:italic;" title="Click this if you want to send the products details of this product as a QA link to your colleague" onclick="sendColleague(10990391, 2);
                                                        return false;">Send this as a QA link to your colleague</a><br><form name="qaform" method="post" action="/productDetail.php" style="display:inline;"><label style="font-style:italic;"><input type="checkbox" name="qa" value="1" onclick="doQA(10990391);">QA Certified</label></form></td>
                                    <td align="left" valign="top" class="bodytext">                                            <a href="pdfContentDetail.php?id=10990391" onclick="productContent(10990391); return false;" class="bluelink" style="font-style:italic;">View Product Content in text format</a>
                                            </td>
                                </tr>
                                                    </tbody></table>
                </div>
                <table border="0" cellspacing="0" cellpadding="4">
                    <tbody><tr><td>&nbsp;</td></tr>
                                                       <tr><td><a href="#" class="HyperLink" onclick="window.close();
                                        return false;" title="Click to Close this window">Close-Window</a></td></tr>
                            </tbody></table>
            </div>`;
      // newTabData.value = item;
      // console.log(newTabData.value.raw.headline.headline);
      const newTab = window.open(
        "",
        "_blank",
        "width=600,height=400,left=200,top=200"
      );
      newTab.document.open();
      newTab.document.write(content);
      newTab.document.close();
    }

    function collateSectorNames(arr) {
      sectorNames.value = [];
      let sector = store.getters["Rawdata/getDropdownDataAPI"]?.sectors;
      sector.forEach((s) => {
        if (arr.includes(s.sectorID)) {
          if (!sectorNames.value.includes(s.sectorName)) {
            sectorNames.value.push(s.sectorName);
            sectorNames.value.sort(function (a, b) {
              if (a < b) {
                return -1;
              }
              if (a > b) {
                return 1;
              }
              return 0;
            });
          }
        }
      });
      return sectorNames.value.join(", ");
    }

    function headlineFnHandler(e) {
      // console.log("XXX", e.target.innerText.trim());
      page.value = 1;
      let apidata = store.getters["Rawdata/getsearchedBodyDataGetters"];

      if (Object.keys(apidata).length !== 0) {
        // console.log(apidata, "apidata");
        switch (
          e.target.innerText.trim() ||
          e.target.parentNode.children[0].innerText
        ) {
          case "Headline":
            isLoading.value = true;
            if (
              sortingIcon.value.headline === "" ||
              sortingIcon.value.headline === "mdi-menu-down"
            ) {
              sortingIcon.value.headline = "mdi-menu-up";
              sortingIcon.value.company = "";
              sortingIcon.value.entry = "";
              sortingIcon.value.a = "";
              sortingIcon.value.s = "";
              sortingIcon.value.g = "";
            } else if (sortingIcon.value.headline === "mdi-menu-up") {
              sortingIcon.value.headline = "mdi-menu-down";
              sortingIcon.value.company = "";
              sortingIcon.value.entry = "";
              sortingIcon.value.a = "";
              sortingIcon.value.s = "";
              sortingIcon.value.g = "";
            }
            console.log(apidata["sortby"], "sss");

            if (
              apidata["sortby"].includes(
                "primary_company_name, desc" || "entry_id_sort, desc"
              )
            ) {
              // alert("first");
              apidata["tiebreaker"] = "product_id, desc";
              for (const [key, value] of Object.entries(apidata)) {
                // console.log(`${key}: ${value}`);
                if (key === "sortby") {
                  if (value === "product_headline_sort, desc") {
                    apidata[key] = "product_headline_sort, asc";
                  } else if (value === "product_headline_sort, asc") {
                    apidata[key] = "product_headline_sort, desc";
                  } else {
                    apidata[key] = "product_headline_sort, asc";
                  }
                }
                if (key === "page_type") {
                  apidata[key] = "1";
                  page.value = 1;
                }
              }
            } else if (
              apidata["sortby"].includes(
                "primary_company_name, asc" || "entry_id_sort, asc"
              )
            ) {
              // alert("second");
              apidata["tiebreaker"] = "product_id, asc";
              for (const [key, value] of Object.entries(apidata)) {
                // console.log(`${key}: ${value}`);
                if (key === "sortby") {
                  if (value === "product_headline_sort, desc") {
                    apidata[key] = "product_headline_sort, asc";
                  } else if (value === "product_headline_sort, asc") {
                    apidata[key] = "product_headline_sort, desc";
                  } else if (
                    apidata[key] == !"product_headline_sort, desc" ||
                    !"product_headline_sort, asc"
                  ) {
                    apidata[key] = "product_headline_sort, asc";
                  } else {
                    apidata[key] = "product_headline_sort, asc";
                  }
                }
                if (key === "page_type") {
                  apidata[key] = "1";
                  page.value = 1;
                }
              }
            } else {
              ////
              for (const [key, value] of Object.entries(apidata)) {
                // console.log(`${key}: ${value}`);
                if (key === "sortby") {
                  if (value === "product_headline_sort, desc") {
                    apidata[key] = "product_headline_sort, asc";
                  } else if (value === "product_headline_sort, asc") {
                    apidata[key] = "product_headline_sort, desc";
                  } else {
                    apidata[key] = "product_headline_sort, asc";
                  }
                } else if (key === "tiebreaker") {
                  if (value === "product_id, desc") {
                    apidata[key] = "product_id, asc";
                  } else if (value === "product_id, asc") {
                    apidata[key] = "product_id, desc";
                  } else {
                    apidata[key] = "product_id, asc";
                  }
                }
                if (key === "page_type") {
                  apidata[key] = "1";
                  page.value = 1;
                }
              }
            }
            searchAPIHit(apidata);
            break;
          case "Company":
            isLoading.value = true;
            if (
              sortingIcon.value.company === "" ||
              sortingIcon.value.company === "mdi-menu-down"
            ) {
              sortingIcon.value.company = "mdi-menu-up";
              sortingIcon.value.headline = "";
              sortingIcon.value.entry = "";
              sortingIcon.value.a = "";
              sortingIcon.value.s = "";
              sortingIcon.value.g = "";
            } else if (sortingIcon.value.company === "mdi-menu-up") {
              sortingIcon.value.company = "mdi-menu-down";
              sortingIcon.value.headline = "";
              sortingIcon.value.entry = "";
              sortingIcon.value.a = "";
              sortingIcon.value.s = "";
              sortingIcon.value.g = "";
            }
            for (const [key, value] of Object.entries(apidata)) {
              // console.log(`${key}: ${value}`);
              if (key === "sortby") {
                if (value === "primary_company_name, desc") {
                  apidata[key] = "primary_company_name, asc";
                } else if (value === "primary_company_name, asc") {
                  apidata[key] = "primary_company_name, desc";
                } else {
                  apidata[key] = "primary_company_name, asc";
                }
              } else if (key === "tiebreaker") {
                if (value === "product_id, desc") {
                  apidata[key] = "product_id, asc";
                } else if (value === "product_id, asc") {
                  apidata[key] = "product_id, desc";
                } else {
                  apidata[key] = "product_id, asc";
                }
              }
              if (key === "page_type") {
                apidata[key] = "1";
                page.value = 1;
              }
            }
            searchAPIHit(apidata);
            break;
          case "Entry ID":
            isLoading.value = true;
            if (
              sortingIcon.value.entry === "mdi-menu-down" ||
              sortingIcon.value.entry === ""
            ) {
              sortingIcon.value.entry = "mdi-menu-up";
              sortingIcon.value.headline = "";
              sortingIcon.value.company = "";
              sortingIcon.value.a = "";
              sortingIcon.value.s = "";
              sortingIcon.value.g = "";
            } else if (sortingIcon.value.entry === "mdi-menu-up") {
              sortingIcon.value.entry = "mdi-menu-down";
              sortingIcon.value.headline = "";
              sortingIcon.value.company = "";
              sortingIcon.value.a = "";
              sortingIcon.value.s = "";
              sortingIcon.value.g = "";
            }
            for (const [key, value] of Object.entries(apidata)) {
              if (key === "sortby") {
                if (value === "entry_id_sort, desc") {
                  apidata[key] = "entry_id_sort, asc";
                } else if (value === "entry_id_sort, asc") {
                  apidata[key] = "entry_id_sort, desc";
                } else {
                  apidata[key] = "entry_id_sort, asc";
                }
              } else if (key === "tiebreaker") {
                if (value === "product_id, desc") {
                  apidata[key] = "product_id, asc";
                } else if (value === "product_id, asc") {
                  apidata[key] = "product_id, desc";
                } else {
                  apidata[key] = "product_id, asc";
                }
              }
              if (key === "page_type") {
                apidata[key] = "1";
                page.value = 1;
              }
            }
            searchAPIHit(apidata);
            break;
          case "A":
            isLoading.value = true;
            if (sortingIcon.value.a === "") {
              sortingIcon.value.a = "mdi-menu-up";
              sortingIcon.value.headline = "";
              sortingIcon.value.company = "";
              sortingIcon.value.entry = "";
              sortingIcon.value.s = "";
              sortingIcon.value.g = "";
            } else if (sortingIcon.value.a === "mdi-menu-up") {
              sortingIcon.value.a = "mdi-menu-down";
              sortingIcon.value.headline = "";
              sortingIcon.value.company = "";
              sortingIcon.value.entry = "";
              sortingIcon.value.s = "";
              sortingIcon.value.g = "";
            }
            for (const [key, value] of Object.entries(apidata)) {
              // console.log(`${key}: ${value}`);
              if (key === "sortby") {
                if (value === "is_digital, desc") {
                  apidata[key] = "is_digital, asc";
                } else if (value === "is_digital, asc") {
                  apidata[key] = "is_digital, desc";
                } else {
                  apidata[key] = "is_digital, asc";
                }
              } else if (key === "tiebreaker") {
                if (value === "entry_id_sort, desc") {
                  apidata[key] = "entry_id_sort, asc";
                } else if (value === "entry_id_sort, asc") {
                  apidata[key] = "entry_id_sort, desc";
                } else {
                  apidata[key] = "entry_id_sort, asc";
                }
              }
              if (key === "page_type") {
                apidata[key] = "1";
              }
            }
            searchAPIHit(apidata);
            break;
          case "S":
            isLoading.value = true;
            if (sortingIcon.value.s === "") {
              sortingIcon.value.s = "mdi-menu-up";
              sortingIcon.value.headline = "";
              sortingIcon.value.company = "";
              sortingIcon.value.entry = "";
              sortingIcon.value.g = "";
              sortingIcon.value.a = "";
            } else if (sortingIcon.value.s === "mdi-menu-up") {
              sortingIcon.value.s = "mdi-menu-down";
              sortingIcon.value.headline = "";
              sortingIcon.value.company = "";
              sortingIcon.value.entry = "";
              sortingIcon.value.g = "";
              sortingIcon.value.a = "";
            }
            for (const [key, value] of Object.entries(apidata)) {
              // console.log(`${key}: ${value}`);
              if (key === "sortby") {
                if (value === "is_panelist_score, desc") {
                  apidata[key] = "is_panelist_score, asc";
                } else if (value === "is_panelist_score, asc") {
                  apidata[key] = "is_panelist_score, desc";
                } else {
                  apidata[key] = "is_panelist_score, asc";
                }
              } else if (key === "tiebreaker") {
                if (value === "product_id, desc") {
                  apidata[key] = "entry_id_sort, asc";
                } else if (value === "entry_id_sort, asc") {
                  apidata[key] = "product_id, desc";
                } else {
                  apidata[key] = "entry_id_sort, asc";
                }
              }
              if (key === "page_type") {
                apidata[key] = "1";
              }
            }
            searchAPIHit(apidata);
            break;
          case "G":
            isLoading.value = true;
            if (sortingIcon.value.g === "") {
              sortingIcon.value.g = "mdi-menu-up";
              sortingIcon.value.a = "";
              sortingIcon.value.headline = "";
              sortingIcon.value.company = "";
              sortingIcon.value.entry = "";
              sortingIcon.value.s = "";
            } else if (sortingIcon.value.g === "mdi-menu-up") {
              sortingIcon.value.g = "mdi-menu-down";
              sortingIcon.value.a = "";
              sortingIcon.value.headline = "";
              sortingIcon.value.company = "";
              sortingIcon.value.entry = "";
              sortingIcon.value.s = "";
            }
            for (const [key, value] of Object.entries(apidata)) {
              // console.log(`${key}: ${value}`);
              if (key === "sortby") {
                if (value === "is_animation, desc") {
                  apidata[key] = "is_animation, asc";
                } else if (value === "is_animation, asc") {
                  apidata[key] = "is_animation, desc";
                } else {
                  apidata[key] = "is_animation, asc";
                }
              } else if (key === "tiebreaker") {
                if (value === "entry_id_sort, desc") {
                  apidata[key] = "entry_id_sort, asc";
                } else if (value === "entry_id_sort, asc") {
                  apidata[key] = "entry_id_sort, desc";
                } else {
                  apidata[key] = "entry_id_sort, asc";
                }
              }
              if (key === "page_type") {
                apidata[key] = "1";
              }
            }
            searchAPIHit(apidata);
            break;
        }
      }
    }
    async function highlight(e) {
      if (e) {
        const stringPatts = e
          .toLowerCase()
          .replace(/[^a-zA-Z ]/g, " ")
          .split(" ");

        // text = text.replace(/"/g, "'");
        // console.log("string", stringPatts);
        let stringHighlight = [];
        // var stringPatts = search.value.split(" ");
        let text = await document.getElementsByClassName("underline");
        for (let k = 0; k < stringPatts.length; k++) {
          if (stringPatts[k].length > 2) {
            stringHighlight.push(stringPatts[k]);
          }
        }
        stringHighlight = stringHighlight.map((val) => {
          return "\\b" + val + "\\b";
        });
        for (let i = 0; i < text.length; i++) {
          var str = text[i].innerText;
          var re = new RegExp(stringHighlight.join("|"), "gi");
          // console.log("WWx", re);
          str = str.replaceAll(re, function replace(match) {
            return "<span style='background: skyblue'>" + match + "</span>";
          });
          text[i].innerHTML = str;
        }
      }
    }
    function pageNumbers() {
      const firstPage = Math.max(1, page.value - 4);
      // console.log("pageNumbers", firstPage);
      const lastPage = Math.min(pageCount.value, page.value + 9);
      return Array.from(
        { length: lastPage - firstPage + 1 },
        (_, index) => firstPage + index
      );
    }

    function openPDF(pid) {
      window.open(
        `https://www.competiscan.com/productDocuments.php?id=${pid} `,
        "_blank",
        "width=700,height=800"
      );
    }
    function openAdminPDFURL(pid) {
      window.open(
        `https://cs.uat.competiscan.com/managepdf/${pid}`,
        "_blank",
        "width=900,height=900"
      );
    }

    function searchAPIHit(apidata) {
      // const bodyPayload = store.getters["Rawdata/getsearchAPIBodyGetters"];
      // console.log(apidata, "pay");
      // console.log(bodyPayload, "bodyPayload");
      fetch(`${http.value.vatBackend}/elasticsearch-service/v1/search/`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(apidata),
      }).then((response) => {
        response.json().then(async (data) => {
          // sector = await resolveAfter2Seconds();
          // console.log("2data", data);
          store.dispatch("Rawdata/setsearchResultAction", data);
          isLoading.value = false;
        });
      });
    }
    return {
      sortCategories,
      catIdSelectedLastSearch,
      dynamicPDFPreview,
      filterPrimaryAndAdditionalCompanies,
      highlight,
      sectorNames,
      pageNumbers,
      searchAPIHit,
      headlineFnHandler,
      headers,
      dataExist,
      pdfHoverPop,
      collateSectorNames,
      searchResultFormatting,
      newdata,
      companyDataSend,
      lastPageStatus,
      networkName,
      timeTaken,
      totalRecords,
      checkWrenchIcon,
      pageCount,
      previewLoadingFetch,
      page,
      pageEventHandler,
      sid,
      isLoading,
      lastResultAPI,
      loading,
      snackbar,
      actioPayload,
      showModal,
      dummypids,
      modalVisible,
      DataTableWidth,
      paginationColor,
      imagePath,
      pdfPath,
      pptPath,
      htmlPath,
      headlineOpenwindow,
      isSearchAgainFlag,
      excelPath,
      lastSearch,
      offerOrigin,
      bodyData,
      downIcon,
      setCookie,
      upIcon,
      mediaChannel,
      openAdminPDFURL,
      openHeadlineFnHandler,
      pdfHoverData,
      iconShow,
      openTabContent,
      offSetTop,
      newTabData,
      logoPath,
      pageData,
      pagesToShow,
      totalPages,
      displayedPages,
      maxPgNum,
      dataStatus,
      paginationPayload,
      search,
      isWrenchIconStatus,
      wrenchIconWhite,
      headlineHover,
      setSearchCriteria,
      persons,
      allMuids,
      isHovering,
      sortingIcon,
      db,
      sectorIdsSelected,
      currentPID,
      myParagraph,
      paraHeight,
      openHtmlTag,
      productDetailPayload,
      sectorHandler,
      highlightedIndex,
      allproductId,
      IntroductoryPricing,
      fileSizes,
      audience,
      openPDF,
      searchCriteria,
      setStickyHeader,
      showpdfPreview,
      tableRef,
      imageNotfound,
      img,
      previewCloseFlag,
      closePreviewBox,
      closePreviewBoxFn,
      previewIMG,
      eachRow,
      islastResultActive,
      openProductDetatilForm,
      delayFn,
      getMuidHandler,
      resultObjFormatting,
      myExcelActivation,
      loaderGIF,
      pdfHoverLoader,
      lengthRecords,
      openHeadlineFnHandler1,
      lastResult,
      getWrenchHandler,
      findDataValue,
      categoriesLastSearchFunction,
      subcategories,
      subsubcategories,
      responseMFlagRest,
      responseMFlagInsurance,
      myexcelActivateStatusLocal,
    };
  },
};
</script>
<style>
.container {
  display: flex; /* Use Flexbox */
}
.v-tooltip > .v-overlay__content {
  background: #fff !important;
  border: 1px solid #646464;
}

.custom-dialog .v-overlay--active {
  background-color: rgba(226, 36, 36, 0.5) !important;
}
.column-secondRow-down {
  display: flex; /* Use Flexbox */
  flex-direction: row;
}

.v-dialog > .v-overlay__content > .v-card {
  box-shadow: none;
  right: 232px;
}
.column {
  display: flex;
  margin: 5px 5px 0 5px;
}

p:not(.column) {
  margin-left: 2px;
}

.cartCheckBox {
  margin-right: 5px;
  margin-left: 18px;
}

.cursor {
  cursor: pointer;
}
.v-table {
  width: v-bind(DataTableWidth);
  margin: 0 auto;
}
table > thead > tr > th {
  background-color: #3f51b5 !important;
  color: white;
  overflow: auto;
  position: sticky;
}

.v-table .v-table__wrapper > table > tbody > tr:not(:last-child) > td,
.table-row {
  border-bottom: thin red;
  border-bottom-style: dotted;
  overflow: hidden !important;
}

.product-image {
  border: 1px solid black;
  cursor: pointer;
  height: 102px !important;
  width: 154px !important;
}
body.v-dialog-open {
  overflow: auto;
}

/* .v-img__img v-img__img--contain {
} */
.popup-pdf {
  overflow: hidden;
  display: none;
  position: absolute;
  border: 2px solid rgb(0, 0, 0);
  background: rgb(255, 255, 255);
  padding: 4px;
  z-index: 100;
  left: 519px;
  top: 517px;
  width: 312px;
  height: 436px;
  opacity: 1;
  transition: all 0.3s linear;
}
.v-overlay
  .v-overlay--absolute
  .v-overlay--active
  .v-theme--myCustomTheme
  .v-locale--is-ltr
  .v-tooltip {
  padding-left: 550px !important;
  padding-top: 200px !important;
}

/* .v-table.v-table--fixed-header > .v-table__wrapper > table {
  border: 1px solid #0055e3;
} */
/*
.v-table
  .v-table--fixed-header.v-table--has-top
  .v-table--has-bottom
  .v-theme--myCustomTheme
  .v-table--density-default
  .v-data-table {
  border: 1px solid black;
} */

.result-row > th {
  color: #fff !important;
}
thead {
  background-color: #3f51b5;
  color: #fff;
  position: sticky;
  top: 0;
}
.entry-id {
  margin-left: 16px;
}

.text-danger {
  color: #1462f3;
}

.underline {
  color: #1462f3;
  text-decoration: underline;
}
.hovering {
  color: #337ab7;
  cursor: pointer;
}

.my-custom-pagination .v-pagination__item {
  background-color: #ff5722; /* Replace with your desired color */
}

table .likeresults td {
  border-width: 1px;
  padding: 4px;
  border-style: dotted;
  border-bottom-color: #d80000;
  border-left: none;
  border-right: none;
  border-top: none;
}

.pdf-link {
  text-decoration: none;
  color: #337ab7;
}

/* .bodytext {
  font-size: 12px;
  color: #505050;
  text-decoration: none;
  line-height: 18px;
} */

.pagination-btn {
  background-color: #c52bca;
  color: #ffff !important;
}

.img-box {
  margin-top: -35px;
}
.v-btn
  .v-btn--disabled
  .v-theme--myCustomTheme
  .v-btn--density-default
  .v-btn--size-small
  .v-btn--variant-elevated {
  border-color: #1462f3 !important;
}

.pagination {
  display: flex;
  list-style: none;
  padding: 0;
}

.pagination li {
  margin-right: 10px;
  cursor: pointer;
}

.pagination li.active {
  font-weight: bold;
}
.heading-text {
  padding-left: 1px !important;
}

#prev span {
  display: inline-block;
}
.second-row {
  margin-top: -35px;
}
.scrollable-table table {
  width: 100%;
  border-collapse: collapse;
}

/* Add borders or other styles for table cells if needed */
.scrollable-table td,
.scrollable-table th {
  border: 1px solid #ccc;
  padding: 8px;
}
.v-overlay__scrim {
  background: transparent !important;
}

.cursor:hover {
  text-decoration: overline;
  color: #fff;
  font-size: 12px;
  font-weight: bold;
}

.top-btns {
  height: 20px !important;
}

@media screen and (min-width: 2560px) and (min-height: 1440px) {
  /* Apply styles specific to 2560x1440 resolution */
  /* For example: */
  .heading-css {
    /* Your styles here */
    font-size: 24px;
    /* Add other styles as needed */
  }
}

@media screen and (min-width: 3440px) and (min-height: 1440px) {
  /* Apply styles specific to 2560x1440 resolution */
  /* For example: */
  .heading-css {
    /* Your styles here */
    font-size: 34px;
    /* Add other styles as needed */
  }
}
</style>
